export const en = {
	locale: "en",
	messages: {
		// Global
		"cancel": "Cancel",
		"discard": "Discard",
		"save": "Save",
		"save_and_close": "Save & Close",
		"create": "Create",
		"saving": "Saving",
		"lets_get_started": "Get Started",
		"default": "Default",
		"make_default": "Make default",
		"select": "Select",
		"preview": "Preview",
		"view": "View",
		"help_hint": "https://guide.digitain.com/article-categories/dgbuilder/",
		"yes": "Yes",
		"no": "No",
		"ok": "Ok",
		"done": "Done",
		"verify": "Verify",
		"send": "Send",
		"publish": "Publish",
		"apply": "Apply",
		"reset": "Reset",
		"manage": "Manage",
		"not_attached": "Not attached",
		"attached": "Attached",
		"link": "Link",
		"target": "Method of opening a link",
		"back": "Back",
		"add": "Add",
		"add_new_one": "Add a New One",
		"edit": "Edit",
		"edit_site": "Edit Site",
		"not_editable": "Not editable",
		"hide": "Hide",
		"delete": "Delete",
		"delete_pr": "Delete Project",
		"required": "Required",
		"not_required": "Not required",
		"label": "Field name",
		"labelProperty": "Label",
		"text": "Text",
		"contentAndForms": "Content & Forms",
		"size": "Size",
		"placeholder": "Placeholder",
		"pattern": "Pattern",
		"errorMessage": "Error Message",
		"visibility": "Visibility",
		"position": "Position",
		"positionDesktop": "Position on Desktop",
		"coming_soon": "Coming soon",
		"isRequired": "Is Required",
		"showPassword": "Show Password",
		"isVisible": "Is Visible",
		"firstname": "First name",
		"lastname": "Last name",
		"fullname": "Full name",
		"description": "Description",
		"keywords": "Keywords",
		"url": "URL",
		"address": "Address",
		"city": "City",
		"mobile": "Mobile",
		"mobileNumber": "Mobile Number",
		"emailOrMobileNumber": "Email or Mobile Number",
		"desktop": "Desktop",
		"enabled": "Enabled",
		"enable": "Enable",
		"disabled": "Disabled",
		"disable": "Disable",
		"input": "Input",
		"goToHome": "Go to Homepage",
		"tryAgainLater": "Please try again later",
		"restore": "Restore",
		"empty_search": "No results found",
		"hours": "Hours",
		"search": "Search",
		"document": "Document",
		"citizenship": "Citizenship",
		"physical": "Physical",
		"dob": "Date of Birth",
		"confirm": "Confirm",
		"success_save_msg": "Date has been successfully saved.",

		// Not Found Page
		"notFoundHeader": "Oops... Page not found",
		"notFoundTxt": "The page you are looking for doesn't seem to exist",

		// Social
		"twitter": "Twitter",
		"social_links": "Social Links",
		"twitter_img_ratio": "Allowed image image size for a banner is 600 X 335 px.",
		"open_graph_img_ratio": "Allowed image image size for a banner is 1200 X 630 px.",
		"social_img_size_max": "Maximum image size for a banner is 3 MB.",

		// Error Messages
		"general_error_msg_title": "The application has encountered an unknown error.",
		"general_error_msg_description": "The application has encountered an unknown error.",

		// Placeholder messages
		"description_placeholder": "Enter page description",
		"shema_description_placeholder": "Enter company description",
		"site_name_placeholder": "Site Name here...",
		"title_placeholder": "Enter page title",
		"state_region_placeholdern": "Enter state/region name",
		"schema_city_placeholder": "Enter city name",
		"postal_code_placeholder": "Enter postal code",
		"phone_number_placeholder": "Enter contact phone number",
		"schema_social_placeholder": "Enter company's profile pages URLs",
		"schema_email_placeholder": "Enter contact email address",
		"country_placeholder": "Enter country name",
		"schema_address_placeholder": " Enter street address",
		"url_placeholder": "Enter website URL",
		"summary_card_placeholder": "Summary Card",
		"username_placeholder": "Enter Twitter @username",
		"name_placeholder": "Enter company name",
		"image_alt_placeholder": "Enter image Alt",
		"organization_placeholder": "Organization",
		"past_link_placeholder": "Paste link here",
		"username": "Username",

		// Tooltips
		"title_tooltip":
			"Keep your title between 50–60 characters to ensure it displays properly in search results. Include your main keyword early for better visibility.",
		"description_tooltip":
			"Write a compelling summary between 120–160 characters. Include your primary keyword and a call to action when appropriate to improve click-through rates.",
		"keywords_tooltip": "It's the best to have them not more than 10% of the description length.",
		"twitter_img_tooltip": "Image size should be 600 x 335 pixels",
		"open_graph_img_tooltip": "Image size should be 1200 x 630 pixels",
		"schema_tooltip":
			"Company's profile pages on different resources, such as Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia, etc. You can add as many URLs, as you wish.",
		"mobile_pattern_tooltip": "The pattern applies to the whole field including the country code.",
		"mode_tooltip":
			"To enable Widgets Light/Dark modes on the website, activate Website Light/Dark modes from Branding section's Settings.",
		"edit_padding": "Edit {direction} Padding",

		// Validation Messages
		"email_required": "Please input your email.",
		"invalid_mail": "Please input a valid email.",
		"input_mail": "Please input your email.",
		"password_required": "Please input your password.",
		"inconsistent_passwords": "The two passwords do not match.",
		"input_phone_number": "Please input your phone number.",
		"invalid_phone_number": "Please input a valid phone number.",
		"please_confirm_password": "Please confirm your password.",
		"invalid_password":
			"The password must contain 8-15 characters, both upper and lower case letters, at least one number and one special character.",
		"required_field": "This field is required.",
		"select_forwarding_url": "Please select forwarding URL",
		"select_destination_url": "Please select destination URL",
		"site_name_msg": "The site name can contain only lowercase Latin letters, numbers, 2-30 characters.",
		"invalid_host": "Invalid host name.",
		"invalid_url": "Invalid URL",
		"empty_string": "Empty string is not allowed.",
		"company_name": "Company name",
		"edit_company_name": "Edit Company Name",
		"edit_project_name": "Edit Project Name",
		"company_name_already_exists": "This company name already exists.",
		"project_name_already_exists": "This project name already exists.",
		"input_company_name": "Enter Company Name.",
		"input_project_name": "Please input project name.",
		"input_script_name": "Please input your script name.",
		"input_script": "Please input your script.",
		"input_script_id": "Please input your {name} ID!",
		"invalid_company_name": 'Company name can only contain upper and lower case letters, numbers, "&" and a space.',
		"seo_settings_title":
			"Keep your title between 50–60 characters to ensure it displays properly in search results. Include your main keyword early for better visibility.",
		"seo_settings_description":
			"Write a compelling summary between 120–160 characters. Include your primary keyword and a call to action when appropriate to improve click-through rates.",
		"seo_settings_keywords": "Maximum length for the keywords section is 1000 characters.",
		"integration_id_label": "{name} ID",
		"support_phone_validation_msg": "Maximum length for the field is 25 characters.",

		// Filter
		"filter": "Filter",
		"sort_by": "Sort by:",
		"sort_by_name": "Name (A- Z)",
		"sort_by_name_desc": "Name (Z- A)",
		"sort_by_creation_new_old": "Date created (New-Old)",
		"sort_by_creation_old_new": "Date created (Old-New)",
		"type": "Type",

		// Login
		"login": "Login",
		"email": "Email",
		"password": "Password",
		"remember_me": "Remember me",
		"sign_up": "Sign up",
		"dont_have_account": "Don't have an account?",
		"forgot_password": "Forgot password?",
		"reset_password": "Reset Password",
		"confirm_password": "Confirm Password",
		"phone_number": "Phone Number",
		"additional_phone_number": "Additional Phone Number",
		"set_password": "Set Password",
		"password_info":
			"Please note, this is recommended pattern to have for user's Password from security standpoint, however you can weaken it up to having 6-20 Latin letters, numbers or special characters.",
		"tfa_title_qr": "Set up 2FA",
		"tfa_title_code": "Enter 6 Digital Code",
		"tfa_desc_qr":
			"Use Google or Microsoft Authenticator app to scan the QR code or manually enter the secret code below.",
		"tfa_alt_text": "Or enter this code into your authentication app.",
		"tfa_enter_title": "Enter 2FA Code",
		"tfa_enter_number": "Enter the number shown in your authenticator app.",
		"tfa_recover_link": "Recover 2FA?",
		"tfa_recover": "Recover 2FA",
		"tfa_recover_desc": "The QR code for the Two Factor Authentication will be sent to the email address below.",

		// Registration Page
		"registration": "Registration",
		"forms_hint": "https://guide.digitain.com/knowledge-base/forms/",
		"register": "Register",
		"agreement1": "I have read the ",
		"agreement2": "agreement",
		"human": "Please pass security check.",
		"name_validation_message": "Please input a valid name.",
		"first_name_required_msg": "Please input your First name.",
		"last_name_required_msg": "Please input your Last name.",
		"agreement_required_msg": "Please confirm that you have read the agreement.",
		"one_click_registration": "One-Click Registration",
		"phone_number_only": "Phone Number (Only)",
		"phone_number_mail": "Switcher (Phone Number + Email/Username)",
		"phone_number_mail_no_id": "Switcher (Phone Number + Email)",
		"combined": "Combined (All In One)",
		"default_switcher_type": "Default Switcher Type",
		"geolocation_info": "This input includes Country/Region/City/District",

		// Forgot Password
		"or": "Or",
		"go_to_login": "Go to Login",
		"send_verification_code": "Get verification code",
		"recover_by": "Recover password via",
		"verification_code_sent": "The verification code has been successfuly sent.",
		"password_changed": "Password has been changed successfully.",
		"change_password_btn": "Change Password",
		"reset_code": "Reset code",
		"password_reset_code": "Input password reset code here",
		"reset_code_required": "Please input reset code",
		"get_reset_code": "Get reset code",
		"send_reset_code_again": "Send again",
		"reset_code_sent": "The code to reset your password has been sent to {name} email.",
		"repeat_in": "Repeat in",
		"forgot_password_section": "Forgot Password",
		"change_password": "Change Password",

		// Forgot username
		"forgot_username_section": "Forgot Username",
		"activate_forgot_username": "Activate Forgot Username",
		"forget_username_btn": `To activate/deactivate functionality, please select 'All languages' option from the drop down above.`,

		// Account Verification
		"email_verification": "Email verification",
		"mobile_verification": "Mobile verification",
		"verification_code": "Verification code",
		"resend_verification_code": "Resend verification code",
		"confirm_verification": "Confirm verification",
		"verification_code_required": "Please input verification code",
		"verification_code_resent": "The verification code has been resent successfully.",

		// Top Menu
		"profile": "Profile",
		"logout": "Logout",

		// Projects
		"projects": "Projects",
		"add_new_site": "Add a new site",
		"my_sites": "My sites",
		"delete_site": "Are you sure you want to delete the site - {site}?",
		"site_state": { 1: "Live", 2: "Blocked", 3: "Trial" },
		"change_status": "Change Status",
		"change_temp_attention_warning":
			"Be aware changing template will remove all configurations from DGbuilder Admin panel made for current template.  Configurations from other admin panels won't be changed.",
		"delete_text":
			"Deleting a site cannot be undone. All data for the site will be lost and cannot be recovered. Please input your account password in order to permanently delete the site.",
		"all_companies": "All companies",
		"status_blocked_text": "In Blocked status the site is temporarily unavailable.",
		"status_trial_text": "In Trial status Domains and Payments management for the site are disabled.",
		"status_live_text": "In Live status the site is fully functional.",
		"check_password_text": "Please input your account password in order to change the site status.",
		"check_password_text_change_temp": "Please input your account password in order to change the template.",
		"company": "Company",
		"empty_projects": "We couldn’t find any sites matching your search.",
		/* My Profile */

		// Profile menu
		"myProfile": "My Profile",
		"adminTools": "Admin Tools",
		"users": "Users",
		"auditLogs": "Audit Logs",

		"change_pass_title": "Click edit for changing current password.",
		"current_password": "Current Password",
		"new_password": "New Password",
		"confirm_new_password": "Confirm New Password",

		"new_email": "New Email",
		"email_id": "Email/Username",
		"save_email_note": "Your new Email will be saved only after verification.",
		"check_email_note": "Please check your Email for verification code.",

		"new_mobile": "New Phone Number",
		"save_mobile_note": "Your new phone number will be saved only after verification",
		"check_mobile_note": "SMS with verification code has been sent to your phone number.",
		"confirm_code": "Confirm Code",
		"first_name_validation_msg": "First name can contain 2-50 characters: only Latin letters, a dash and a space.",
		"last_name_validation_msg":
			"Last name can contain 2-50 characters: only Latin letters, dash, apostrophe and spaces.",
		"incorrect_password": "Your current password is incorrect",
		"status_has_changed": "Status has been successfully changed",
		"choose_company_first": "Please select the Company first.",
		"choose_new_template": "Choose  New Template",
		"created_by": "Created By",
		"roles": "Roles",
		"role": "Role",
		"companies": "Companies",
		"add_company": "Add Company",
		"add_new_company": "Add new company",
		"edit_user_state_title": "Activity Status Change",
		"edit_user_state_text": "Are you sure you want to change users activity status to {name}?",
		"requests": "Requests",
		"requested_by": "Requested By",
		"provided_to": "Provided To",
		"requested_at": "Requested At",
		"operated_by": "Operated By",
		"operated_at": "Operated At",
		"action_type": "Action Type",
		"createdUser": "Created User",
		"modifiedCompany": "Modified Company",
		"modifiedRole": "Modified Role",
		"modifiedProjects": "Modified Projects",
		"modifiedName": "Modified Name",
		"modifiedExpirationDate": "Modified Expiration Date",
		"modifiedActivityStatus": "Modified Activity Status",
		"request_action_type_info": '{userFrom} <span>"{actions}"</span> for <a href="mailto:{userTo}" >{userTo}</a>',
		"request_approve_confirm": "Are you sure you want to approve this request?",
		"request_approve_title": "Approve Request",
		"request_cancel_confirm": "Are you sure you want to cancel this request?",
		"request_cancel_title": "Cancel Request",
		"request_reject_confirm": "Are you sure you want to decline this request?",
		"request_decline_title": "Decline Request",
		"cancel_request": "Cancel Request",
		"comment_required": "Please input your comment.",
		"details": "Details",
		"close": "Close",
		"approve": "Approve",
		"projectsAdded": "Projects Added",
		"projectsRemoved": "Projects Removed",
		"expirationDate": "Expiration Date",
		"text_copied": "Copied",
		"activityStatus": "Activity Status",
		"all": "All",
		"approved": "Approved",
		"declined": "Declined",
		"decline": "Decline",
		"canceled": "Canceled",
		"comment": "Comment",
		"comment_optional": "Comment (Optional)",

		// Settings
		"settings": "Settings",
		"overview": "Overview",
		"language": "Language",
		"languages": "Languages",
		"banners_managment": "Banner Management",
		"banners_managment_hint": "https://guide.digitain.com/knowledge-base/banners/",
		"captcha": "Captcha",
		"currencies": "Currencies",
		"sms": "SMS",
		"smtp": "SMTP",
		"search_here": "Search",
		"custom_image": "Custom Image",
		"custom_image_tooltip": "SVG format is not supported for Mobile applications.",
		"payments": "Payments",
		"domains": "Domains",
		"logos": "Logos",
		"logo_block_description":
			"Maximum size for the image is 1MB. Supported formats for uploading logos: jpeg, png, gif, svg and webp.",
		"logos_hint": "https://guide.digitain.com/knowledge-base/branding/#logo",
		"destination": "Destination",
		"general_settings": "General Settings",
		"mobile_settings": "Mobile Settings",
		"cookies_storing": "Cookies storing period in days",
		"products": "Products",
		"go_to_settings": "Go to settings",
		"api_key": "API Key",
		"secret_key": "Secret Key",
		"setting_changed": "Data has been changed successfully.",
		"click_here": "Click here",
		"on": "On",
		"off": "Off",
		"widgets": "Widgets",
		"sport_top_matches": "Sport Top Matches",
		"sport_prematch_top_matches": "Prematch Top Matches (Total Market Included)",
		"live_and_prematch_top_matches": "Live & Prematch Top Matches",
		"multibet_of_the_day": "Multibet of the Day",
		"super_promotions": "Super Promotions",
		"live_top_matches": "Live Top Matches",
		"sport_jackpot": "Sport Jackpot",
		"sport_fixed_scroll": "Sections scrolling",
		"sport_site_styles": "Inherit Website color",
		"sport_deactivation_title": "Deactivate Sportsbook",
		"sport_deactivation_msg": "Are you sure you want to deactivate Sportsbook",
		"casino_widget_deactivation_title": "Deactivate Casino Widget",
		"casino_widget_deactivation_msg": "Are you sure you want to deactivate Casino Widget?",
		"copy_intercom_id": "Copy your Intercom ID and paste it to the field below.",
		"copy_hotjar_id": "Copy your Hotjar Site ID and paste it to the field below.",
		"copy_zendesk_id": "Copy the widget ID from the embed script of the Zendesk Chat.",
		"copy_google_id": "Copy your Google Analytics Tracking ID and paste it to the field below.",
		"copy_google_console_id":
			"To verify website ownership, click on HTML tag verification method in your Google Search Console account, copy the code (content value in meta tag) and paste it in the field below. Afterwards, click Verify in Verify Ownership popup in your Google Search Console account.",
		"learn_more": "Learn more…",
		"integrate": "Integrate",
		"enter_script_name": "Enter your script name",
		"enter_head_script": "Enter your head tag script",
		"enter_body_script": "Enter your body tag script",
		"enter_scrpt_id": "Enter your {name} ID",
		"google_console_label": "Google site verification code",
		"google_console_error_msg": "Please input your Google site verification code",
		"google_console_placeholder": "Please input your Google site verification code",
		"whatsapp_number_label": "WhatsApp number",
		"whatsapp_number_placeholder": "Enter your WhatsApp number",
		"whatsapp_number_error_msg": "Enter your WhatsApp number",
		"color_activation_text_1":
			"Be aware, after activating Light/Dark modes the website pages, website popups, widget based pages and footer will inherit the current color set configurations as the default color mode.",
		"color_activation_text_2":
			"It is also possible to set custom Light/Dark mode colors for widget based Footer and widget based custom Pages.",
		"color_deactivation_text_1":
			"Be aware, after deactivating Light/Dark modes the website pages, website popups, widget based pages and footer will inherit default mode's color set configurations as website color set. Configurations for second color mode will be saved for future activation.",
		"activate_attention_text_1":
			"Be aware, after activating Light/Dark modes the widgets will inherit current color set configurations as default color mode.",
		"activate_attention_text_2":
			"An additional activation and configuration will be needed for widget-based Footer and Custom Pages.",
		"activate_attention_text_3":
			"Activate Website Light/Dark modes from Branding section's Settings to enable Widgets Light/Dark modes on the website.",
		"activate_attention_text_4": "The overlap configuration applied to the widgets will be removed.",
		"deactiate_overlap_text_mobile": "Deactivate Overlap on Mobile",
		"deactiate_overlap_text": "Deactivate Overlap on Desktop",
		"deactivate_attention_text":
			"Be aware, after deactivating Light/Dark modes the footer will inherit default mode's color set configurations as website color set. Configurations for second color mode will be saved for future activation.",
		"reject": "Reject",

		// Products
		"choose_products": "Choose which products would you like to activate for your website.",
		"sport_description":
			"By Sportsbook product activation you will get access to a comprehensive multi-lingual, multi-currency, customizable interface with live and pre-match events for 65+ sports, 7 500 leagues worldwide and over 3 000 betting markets.",
		"casino_description":
			"By Casino products configuration on Platform side you will get access to a comprehensive multi-lingual, multi-currency, fully customizable Lobby management with 10,000+ Casino Games.",
		"casino_widgets": "Casino Widgets",
		"casino_jackpot": "Casino Jackpot",
		"relum_jackpot": "Relum Jackpot",
		"relumjackpot": "Relum Jackpot",
		"edit_relum_jackpot": "Edit Relum  Jackpot",
		"set_name": "Set Name",
		"casino_switcher":
			"By switching on the widget, it will not be shown on the website without a configuration in Admin Panel",
		"sportsbook": "Sportsbook",
		"casino": "Casino",
		"deactivate": "Deactivate",
		"activate": "Activate",
		"sport_change_type_msg": "Are you sure you want to change Sport View?",
		"sport_change_type_title": "Change Sportsbook view",
		"esport_change_type_msg": "Are you sure you want to change Esport View?",
		"sport_type": "Change Sportsbook view",
		"sport_type_title": "Select Sportsbook View",
		"esports_view_title": "Select Esports view",
		"esport_change_type_title": "Change ESport view",
		"scroll_option": "Scrolling type On Desktop",
		"scroll_option_info": "The setting applies to the Standard sportsbook view.",
		"color_option": "Website Colors",
		"color_option_info": "The setting applies to all sport pages.",
		"integration_type": "Integration Type on Mobile",
		"change": "Change",
		"standard": "Standard",
		"african": "African",
		"latin": "Latin",
		"paper": "Paper",
		"asian": "Asian",
		"modern": "Modern",
		"iframe": "Iframe",
		"native": "Native",

		// Overview
		"statuses": "Statuses",
		"preview_site_label": "Preview site",
		"rename_site_label": "Rename site",
		"duplicate_site_label": "Duplicate site",
		"delete_site_label": "Delete site",
		"quick_actions": "Quick actions",
		"overview_desc":
			"Here you can see which settings are already done for your website and which ones are missing. Please note, that all of them are required for going live.",
		"site_address": "Site address",
		"cahnage_template": "Change Template",

		// Languages
		"add_language": "Add a New Language",
		"language_delete_confirmation":
			"All language-specific settings and content (banners, forms, menu items, SEO, etc.) will be recovered after the language reactivation.",
		"information": "Information",
		"language_bar": "Language Bar",
		"language_bar_hint": "https://guide.digitain.com/knowledge-base/controls/#language-bar",
		"show_language_bar": "Show language bar",
		"selected_language": "Selected language",
		"language_list": "Language list",
		"language_name": "Language name",
		"language_code": "Language code",
		"only_flag": "Flag",
		"flag": "Flag",
		"flag_with_language_name": "Flag with language name",
		"flag_with_language_code": "Flag with language code",
		"edit_before_leave_msg": "Are you sure you want to leave without saving the changes?",
		"attention": "Attention",
		"mobil_flag_info": "Flags are displayed only in desktop version",

		// Currency
		"currency": "Currency",
		"add_currency": "Add a New Currency",
		"currency_delete_confirmation":
			"The currency will be removed from the list on the website. Players using this currency will not be affected. If you want to fully deactivate the currency and not support it any more, please contact your account manager.",

		// Payments
		"add_payment_method": "Add payment methods",
		"max_withdrawal_short": "Max withdr...",
		"max_withdrawal": "Max withdrawal amount",
		"min_withdrawal_short": "Min withdr...",
		"min_withdrawal": "Min withdrawal amount",
		"min_deposit_short": "Min depo...",
		"min_deposit": "Min deposit amount",
		"max_deposit_short": "Max depo...",
		"max_deposit": "Max deposit amount",
		"credit_percent": "Credit %",
		"debit_percent": "Debit %",
		"state": "State",
		"payment": "Payment",
		"monochrome": "Monochrome",
		"white": "White",
		"colored": "Colored ",
		"colored_with_background": "Colored with background",
		"default_state_type": "Default State Type",
		"hover_state": "Hover State",

		// Domain
		"domain": "Domain",
		"add_domain": "Add a New Domain",
		"change_url": "Change URL",
		"new_url": "New URL",
		"connect_domain": "Connect your domain",
		"domain_required": "Please input domain.",
		"domain_validation_message": "Please insert valid domain",
		"domain_name": "Domain name",
		"your_domain_name": "What's your domain name?",
		"domain_max_count_text":
			"Maximum number of Forwarding URL for your website is reached. You can only replace existing ones.",
		"status": "Status",
		"remove_domain": "Remove domain",
		"no_data": "No data",
		"pending": "Pending",
		"inProcess": "In Process",
		"creationInProcess": "Creation In Process",
		"verificationInProcess": "Verification in Process",
		"readyToVerify": "Ready to Verify",
		"failed": "Failed",
		"active": "Active",
		"inactive": "Inactive",
		"name_servers_info": "Name Servers information",
		"domain_redirection": "Domain Redirection",
		"no_rule": "No rule created yet",
		"no_rule_description": "Here you can add a permanent redirection rule for one of your website’s active domains.",
		"add_new_rule": "Add a New Rule",
		"domain_rules_desc": "Here you can add a permanent redirection rule for one of your website’s active domains.",
		"domain_redirection_rules_desc":
			"The redirection URL when creating one to indicate the process is being done and it may take a while.",
		"domain_redirection_url": "Redirection URL",
		"domain_redirection_url_in_process": "Redirection URL In Process",
		"market_selection": "Activate Regulated Market Configuration",
		"regulated_market": "Regulated Market",

		"forwarding_url": "Forwarding URLs",
		"destination_url": "Destination URL",
		"select_domain": "Select a domain",
		"delete_the_rule": "Delete the rule",
		"delete_rule": "Delete rule",
		"delete_rule_conf": "Are you sure you want to delete the rule.",
		"rule_delete_warning":
			"{name} cannot be deleted because there is a domain redirection rule related to it. Please delete or edit the rule first.",
		"rule_delete_button": "Ok, Got it",
		"rule_delete_warning_title": "Delete domain",

		"are_you_sure_to_remove_domain": "Are you sure you want to delete {name} domain?",
		"domain_added": "Domain added",
		"verification_sent": "Domain Verification is successfully sent",

		"domain_instructions_titile_1": "Login to your domain provider",
		"domain_instructions_paragraph_1":
			"Your domain provider is the company where you purchased it (e.g., GoDaddy, eNom, 1and1).",

		"domain_instructions_titile_2": "Go to your domain DNS/Nameservers settings.",
		"domain_instructions_paragraph_2_1": "Find your domain management page.",
		"domain_instructions_paragraph_2_2": "Go to your domain DNS/Nameservers settings.",

		"domain_instructions_titile_3": "Update your domain nameservers",
		"domain_instructions_paragraph_3_1": "Go to your domain DNS/Nameservers settings.",
		"domain_instructions_paragraph_3_2": "Replace ",
		"domain_instructions_paragraph_3_3": " all your current nameservers ",
		"domain_instructions_paragraph_3_4": "with these custom nameservers:",

		"domain_instructions_titile_4": "Verify your domain connection",
		"domain_instructions_paragraph_4": "Check that your domain settings were updated.",
		"reached_domains_hint": "Maximum number of domains for your website is reached",
		"domains_max_count_alert": `You have used <b>{count} of {limit}</b> your domains limit`,
		"domains_max_count_reached_alert": `You have used <b>{count} of {limit}</b> your domains limit. Maximum number of domains for your website is reached.`,
		"previous_errors": "Previous Errors",
		"error_details_desc":
			"This error message indicates a problem with activating the domain for your website. Ensure the given error is addressed correctly and try again. Contact support for assistance if the issue persists.",

		// SMTP
		"provider": "Provider",
		"use_ssl": "Use SSL",
		"mail_from_required": "Please input sender email.",
		"mail_from": "Sender email address",
		"mail_provider": "Send email via",
		"mail_from_name": "Sender name",
		"mail_support": "Support email",
		"mail_from_name_required": "Please input sender name.",
		"sender_name_validation_message": "Menu name can contain up to 50 characters",

		// Logo
		"upload_logo": "Click to Upload",
		"upload_logo_drag": "Drag and Drop Here or ",
		"upload_mobile_logo": "Upload Mobile Logo",
		"image_size_max": "Maximum image file size is 500kb.",
		"upload_image_size_max_50kb": "Maximum image file size is 50kb.",
		"image_type_error": "Only files with the following extensions are allowed: jpg, png, gif, svg, webp",
		"image_type_error_icons": "Only PNG, SVG, WebP files are allowed",
		"main_logo": "Main Logo",
		"mobile_logo": "Mobile Logo",
		"default_logo": "Default",
		"favicon": "Favicon",
		"upload_favicon": "Upload a Favicon",
		"invert": "Invert",
		"invert_logo_hint":
			"You may need to reverse your website logo for some cases such as Light/Night modes. The invert logos should have the same sizes.",
		"app_logo": "App Logo",
		"app_logo_hint":
			"The logo will be visible on the Application downloading suggestion pop-up and used for website pages added on the phone home screen. Recommended image size for the suggestion pop-up is 48x48px. Supports only jpeg, png, and webp formats.",

		// Captcha
		"invalid_input_value": "Invalid value",
		"api_key_validation_msg": "Please input valid API Key",
		"secret_key_validation_msg": "Please input valid Secret Key",

		// General
		"age_restriction": "Age Restriction",
		"market": "Market",
		"age_restriction_description1": "Choose what age you'd like to choose as minumum required age for your users.",
		"age_restriction_description2": "People under that age will not be able to register.",
		"market_restriontion_description": "Select the market. Users from that market can register on your web page.",
		"country": "Country",
		"hidden_section_tooltip_msg": "This functionality is available only for live projects.",
		"age_restriction_validation_msg": "Please input a natural number between 16 and 99.",
		"animation_speed_validation_msg": "Please input a number between 0.5 and 15.",

		// Banners
		"status_live": "Live",
		"status_expired": "Expired",
		"status_scheduled": "Scheduled",
		"status_image": "Image",
		"status_video": "Video",
		"all_devices": "All devices",
		"all_statuses": "All statuses",
		"all_types": "All types",
		"all_banners": "All banners",
		"banner_visibility": "Visibility",
		"next": "Next",
		"add_banner": "Add Banner",
		"edit_banner": "Edit Banners",
		"banner_name": "Banner Name",
		"banner_type": "Banner Type",
		"image": "Image",
		"video": "Video",
		"yt_video_url": "Only YouTube shorts links are supported",
		"story_type": "Story Type",
		"story_video_validation_msg": "Only YouTube shorts links are supported",
		"story_video_link_description": "Paste YouTube shorts link here...",
		"invalid_yt_shorts_url": "Invalid YouTube shorts link",
		"invalid_yt_url": "Invalid YouTube link",
		"video_link_description": "Paste video link here...",
		"banner_name_required_message": "Please input banner name",
		"banner_name_validation_message": "Banner name can only contain letters, numbers, dash and underscore",
		"banner_language_required_message1": "Please select at least one language",
		"banner_language_required_message2": "Please select language",
		"banner_select_target_group_message": "Please select group",
		"banner_name_required_message2": "Banner name field is required.",
		"target_group": "Target Group",
		"empty_target_msg": "No Target Groups",
		"alt_text": "Alt Text",
		"alt_text_here": "Alt Text here...",
		"url_link": "URL Link",
		"how_to_open": "How to Open",
		"start_date": "Start Date",
		"set_start_date": "Please set Start Date",
		"start_time": "Start Time",
		"end_date": "End Date",
		"end_date_required_message": "Please set End Date",
		"end_time": "End Time",
		"device_type": "Device type",
		"mobile_platforms": "Mobile platforms",
		"ios_app": "iOS App",
		"android_app": "Android App",
		"ios_web": "iOS Web",
		"android_web": "Android Web",
		"other_web": "Other Web",
		"mobile_platforms_placeholder": "Please select mobile platform",
		"how_to_open_tooltip": "Works only on Desktop and Web Mobile Device Types",
		"enable_on_live_website": "Enable on Live Website",
		"add_banner_name": "Please add the image for banner",
		"add_banner_video": "Please add the video for banner",
		"end_start_date_required_message": "Please set Start and End Date",
		"end_and_start_date": "Start and End Date",
		"date_and_time": "Set  Date and Time",
		"date_and_time_label": "Date and Time",
		"recurring": "Recurring",
		"repeatOn": "Repeat on",
		"specifyTime": "Specify Time",
		"description_here": "Description here...",
		"banners": "Banners",
		"banner": "Banner",
		"slider_animation_type": "Slider Animation Type",
		"animation_speed": "Animation Speed (Seconds)",
		"autoplay": "Autoplay",
		"show_pagination": "Show Paginaion",
		"pagination": "Pagination",
		"show_arrows": "Arrows",
		"banner_name_already_exists": "Banner with provided name already exists.",
		"image_block_name_already_exists": "Image with provided name already exists.",
		"banner_file_valiation_message": "Only files with the following extensions are allowed: jpg, png, gif, webp",
		"empty_banner":
			"You don’t have any added banner management yet. Click “Add a New One” to see all the options available.",
		"section_visibility": "Section visibility",
		"verification_type": "Verification Type",
		"registration_setting_hint": "The Verification type does not apply for One-Click Registration.",
		"formattingOption": "Formatting Option",
		"noFormatting": "No Formatting",
		"isoFormatting": "ISO Standard Formatting",
		"show_counter": "Counter",
		"arrows_position": "Arrows and Counter Position",
		"top_left": "Top Left",
		"top_right": "Top Right",
		"bottom_left": "Bottom Left",
		"bottom_right": "Bottom Right",
		"banner_grid": "Banner grid",
		"banner_grid_view": "Banner grid view",
		"banner_grid_not_available": `The functionality isn't available for this section`,
		"BannerGrid_hint": "https://guide.digitain.com/knowledge-base/banners/#banner-grid",
		"banners_limit_hint": "The maximum number of elements in viewport is 3.",
		"section": "Section",
		"sections": "Section(s)",
		"responsive_grid": "Responsive Grid",
		"horizontal_scrolling": "Horizontal Scrolling",
		"click_to_modify": "Click to modify section",

		// Image Block
		"image_block_name_validation_message":
			"Name can contain 2-50 characters: letters, spaces, special character _ and numbers.",
		"image_section_name_validation_message":
			"Block name can contain 2-50 characters: letters, numbers, spaces and special characters - and _.",
		"image_block_name_required_message": "Please input image name",
		"add_image_block": "Please add the image for image block",
		"image_block_description":
			"Here you can add images that you would like to be displayed in your website's footer. Recommended image size in this section is 150x60px. You can upload .jpg, .gif, .png, .webp images. In order to maintain best image quality, upload images in a .webp format.",
		"image_block_title_hint": "https://guide.digitain.com/knowledge-base/controls/#image-block",
		"image_block_delete_confirmation": "Are you sure you want to delete {name} from Image Block?",
		"image_section_delete_confirmation":
			"Attention! All the images in block will be removed in case of deleting the block.",
		"image_block_show_section": "Show Block name on website",
		"image_block_create_btn": "Create Block",
		"image_block_add_btn": "Add image to block",
		"image_section_required_name": "Block name field is required",
		"image_section_create_title": "Create Block",
		"image_section_edit_title": "Edit Block",
		"image_block_create_btn_tooltip":
			"To add a Image Block, please select 'All languages' option from the drop down above.",
		"image_block_empty_title": "Image Block List is Empty",
		"image_block_empty_text": "You don't have any added Image Block yet.",
		"image_block_invalid_translation_key":
			"Translation key can contain 2-30 characters: only Latin letters, numbers and special characters - and _.",
		"image_block_upload": "Image Upload",
		"image_block_already_exists": "Block name already existsf.",
		"image_block_create_block_button":
			"To create a block, please select 'All languages' option from the drop down above.",

		// Story Block
		"story_block_description":
			"Here you can add blocks for your marketing campaigns or features on your website Homepage.",
		"story_block_empty_text": "You don’t have any added Story Block yet.",
		"story_block_add_btn": "Add story to block",
		"story_image_block_upload": "Add Story",
		"story_block_title": "Story Management",
		"story_block_icon": "Story Block icon",
		"story_recommended_image_size": "Recommended image size is 122 x 122 px",
		"story_upload_image_size": "Recommended image size is 1080 x 1920 px",
		"add_story_block": "Please add the image for story block",
		"add_story_video": "Please add the video for story block",
		"story_block_name_required_message": "Please input story name",
		"story_block_title_hint": "https://guide.digitain.com/knowledge-base/controls/#story-block",
		// Background image
		"background_image": "Background Image",
		"background_image_hint": "https://guide.digitain.com/knowledge-base/branding/#background-image",
		"all_backgrounds": "All Backgrounds",
		"body": "Body",
		"empty_background_image": "In this section you can add and manage backgrounds for your website.",
		"empty_title": "This Section is Empty",
		"all_pages": "All Pages",
		"choose_fit": "Fit type",
		"background_type": "Background type",
		"background_size_requirement":
			"Recommended image size width in this section is 1920px for Desktop, 1024px for Mobile.",
		"background_position": "Background Position",
		"fill": "Fill",
		"repeat": "Repeat",
		"fit": "Fit",
		"fixed": "Fixed",
		"bg_img_required_message": "Please add the image for background image",
		"bg_type_required_message": "Please select background type",
		"bg_position_required_message": "Please select background position",
		"bg_fit_required_message": "Please select background fit",
		"bg_page_required_message": "Please select background page",
		"add_background_image": "Add Background Image",
		"delete_background_image": "Are you sure you want to permanently delete the background image?",
		"bg_img_delete_success": "Background Image has been successfully deleted",
		"background_disabled_success": "Background Image has been successfully disabled",
		"background_enabled_success": "Background Image has been successfully enabled",
		"bg_upload_image_size_max": "Maximum image size for a Background Image is 1 MB.",
		"bg_pages_tooltip": " Only one image of a type can be uploaded for a specific page.",
		"empty_search_background": "We couldn’t find any background images matching your search.",

		// 3rd party integrations
		"third_party_integrations": "3-rd Party Integrations",
		"third_party_integrations_desc1":
			"Enhance your website functionality by integrating 3-rd party products. Provide your unique ID for that product and all is set. Any other products can be added to the website by using",
		"third_party_integrations_desc2": "Custom Scripts.",
		"my_integrations": "My Integrations",
		"integrate_custom_script": "You can integrate your own script.",
		"third_party_delete_confirmation": "Are you sure you want to delete ”{script}” from your site?",
		"empty_integrations": "You have integrated all available 3-rd party products.",
		"third_party_integrations_empty_desc": "You don't have any integrated 3-rd party products yet.",

		"show_on_website": "Show on Live Website",
		"show_on_website_tooltip":
			"When you turn off this switcher the 3-rd party's icon will be hidden from the home page of your site.",
		"connect": "Connect",
		"script": "Script",
		"head_script": "Inside </head/> tag",
		"body_script": "Before closing </body> tag",

		// Custom Codes
		"custom_codes": "Custom Codes",
		"custom_code_description":
			"In this module you can put your custom script and custom style. Also, you can change styles and integrate new applications into your created project.",
		"custom_script": "Custom Scripts",
		"custom_scripts_description":
			"You can integrate new applications or add different functionality to your website by adding custom scripts.",

		"custom_styles": "Custom Styles",
		"edit_custom_style": "Edit Custom Style",
		"custom_styles_description":
			"You can change UI components' styles and further customize your website's frontend by adding custom styles.",
		"script_name_validation_message":
			"Name field can contain min. 2, max. 55 characters, Latin letters, numbers and the following special characters: (, -, _, ).",

		/* UI Customizaion */
		"styles": "Styles",
		"controls": "Controls",
		"forms_management": "Forms",
		"always": "Always",
		"once": "Once",
		"never": "Never",
		"field_editing_options": "Field Editing Options",
		"field_editing_options_info":
			"You can choose how often the player can edit filed information in My Profile section of the website. The player can't edit/fill field information when option 'Never' is selected. Field information can be filled only once (it can't be edited if it's already filled) if you select 'Once' and it can be edited anytime, if the 'Always' option is selected.",
		"add_sub_menu": "Drop to create a sub-item",
		"visible_items_count": "Visible items count",
		"visible_items_count_info": "You can set how many menu items to show on website.",
		"visible_items_count_placeholder": "Set visible items count",
		"desktop_navigation": "Desktop Navigation",
		"sidebar_icon_visibility": "The icon will be displayed on all device types where it is enabled",
		"generalNavBar": "General",
		"sportNavBar": "Sport",
		"casinoNavBar": "Casino",
		"link_tooltip": "Constrain Proportions",
		"unpin": "Unpin",
		"pin_on_header": "Pin on Header",
		"form_item_pattern_message": "{name} can contain 2-30 characters, including Latin letters, numbers and spaces",

		// SEO
		"seo": "SEO",
		"seo_settings": "SEO Settings",
		"seo_social": "Open Graph/Twitter",
		"seo_schema_markup": "Schema Markup",
		"seo_settings_intro":
			"Optimize your website so that search engines will understand it better and give it higher rankings.",
		"seo_social_intro": "Manage the content that shows up when a website page is shared on social networks.",
		"seo_schema_generator_intro":
			"Schema markup is used to more clearly provide information about your company to search engines in order to understand your content. Your website schema will be automatically generated based on the information you fill in the following fields.",
		"seo_openGraph": "Open Graph",
		"website": "Website",
		"card": "Card",
		"copy_all_pages": "Copy to All Pages",
		"postal_code": "Postal Code",
		"state_region": "State/Region",
		"add_new": "Add a New One",
		"enter_page_title": "Enter page title",
		"seo_enter_keywords": "Enter keywords",
		"page_title_required": "Page title field is required.",
		"twitter_username": "Site (Twitter @username)",
		"seo_schema_settings_saved": "Seo Schema Settings saved",
		"seo_settings_saved": "Seo Settings saved",
		"seo_sitemap": "Sitemap",
		"seo_sitemap_description": "You can either use auto-generated files or contact our Support for other options.",
		"seo_sitemap_files": "Auto-generated files",
		"image_display_mode": "Image Display Mode",
		"display_mode_text":
			"Choose how players view content on the website for the following sections: login/registration and account pages (e.g., profile, cashier, security, bonuses), either in a popup or as a full page.",
		"login_registration": "Login/ Registation",
		"account_section": "Account Section",
		"account_section_tooltip": "This also applies to Header Bonuses Link, Account Menu Links",
		"account_pages_display_mode": "Account Pages Display Mode",
		"account_pages_display_mode_note":
			"After making changes, any custom links that are not system-generated will need to be manually updated to reflect the new behavior. System default menu items will be updated automatically. Full links list can be found here.",
		// configurations
		"configurations": "Configurations",
		"open_graph_block_empty_title": "Open Graph List is Empty",
		"opengraph_rules_empty_text": "You don't have any added Open Graph yet.",
		"new_opengraph_rule": "New Open Graph Rule",
		"opengraph_rules_hint": "https://guide.digitain.com/knowledge-base/settings/#open-graph-twitter",
		"opengraph_rules_image_valiation_message": "Only files with the following extensions are allowed: jpg, png",
		"opengraph_rule_url_tooltip":
			"The URL input should be relative to the websites main domain, e.g. https://example.com/[URL]",
		"open_graph_img_recommendation": "Recommended image size is 1200 x 630 px",
		"opengraph_delete_success": "Rule has been successfully deleted",
		// Dragger
		"dragger_message1": "Drag and Drop Here or",
		"dragger_message2": ".jpg, .gif, .png, .webp",
		"dragger_message3": "Video Link",
		"dragger_message4": ".jpg, .gif, .png, .svg, .webp",
		"dragger_message5": "Click to Upload",
		"dragger_message6": ".jpg, .png",
		"dragger_message7": "Recommended icon size 24x24px, .png, .svg, .webp",

		// Add-ons
		"add_ons": "Add-ons",
		"add_ons_user_validation_title": "{name} market {version}",
		"add_ons_user_validation_required_fields": "Required fields for Registration and My Profile forms are:",
		"add_ons_turkishservicevalidation_desc2": (
			<div className="required-fields">
				<span>Country</span>
				<span>Passport/ID number</span>
				<span>First name</span>
				<span>Last name</span>
				<span>Birthdate</span>
			</div>
		),
		"add_ons_russianservicevalidation_desc2": (
			<div className="required-fields">
				<span>Mobile Number</span>
				<span>Email</span>
				<span>Birthdate</span>
			</div>
		),
		"add_ons_russianservicevalidation2_desc2": (
			<div className="required-fields">
				<span>Mobile Number</span>
				<span>Email</span>
				<span>Birthdate</span>
			</div>
		),
		"add_ons_brazilianservicevalidation_desc2": (
			<div className="required-fields">
				<span>CPF number</span>
			</div>
		),
		"add_ons_user_info_validation_title": "User info validation",
		"add_ons_user_info_validation_subtitle":
			"The service allows to verify user information for market residents before they can be registered on the website.",
		"add_ons_cookies_title": "Cookies",
		"add_ons_cookies_subtitle": "The website uses cookies for some of the applications. ",
		"add_ons_cookies_required_fields":
			"You can activate cookies message for the website, in order to inform site visitors. You can customize the message from admin panel.",
		"add_ons_deactivate_txt": "Are you sure you want to deactivate?",
		"add_ons_turkishservice_deactivate_txt": "Deactivate User info validation",
		"cookies_deactivate_txt": "Are you sure you want to deactivate?",
		"market_validation_info": "Activate user info validation",

		// dev tools
		"note": "Note: ",
		"upload_icon_note":
			"The uploaded image is compatible with both light and dark modes when provided in SVG monochrome format.",
		"upload_icon_img_required": "Please add an image.",
		"upload_icon_type_error": "Only files with the following extensions are allowed: png, webp",
		"dev_tool": "Development Tool",
		"clear_website_cache_title": "Clear Webiste Cache",
		"clear_website_cache_desc1":
			"Clear cached files to force cloud to fetch a fresh version of all files from your web server. It may take up to 30 seconds for changes to take affect.",
		"clear_website_cache_desc2":
			"Purging the cache may temporarily degrade performance for your website and increase load on your origin.",
		"clear_application_cache_title": "Clear Application Cache",
		"clear_application_cache_desc1":
			"Clear cached data to force website to fetch a fresh version of the data from database. All the data will be purged at once.",
		"clear_application_cache_desc2":
			"Purging the cache will temporarily degrade performance for your website and increase load on your origin.",
		"project_cdn_title": "Project CDN URL",
		"project_cdn_desc":
			"This section allows you to set the CDN URL for your website. The selection you make will determine the availability of certain features in the admin panel.",
		"project_cdn_btn": "Setup CDN URL",
		"clear_cache": "Clear Cache",
		"clear_cache_deactivate_txt": "Clear all cached files. Clear  your cache may slow your website temporarily.",
		"confirm_clear_cache": "Confirm Clear Cache",
		"clear_cache_success": "Cache cleared successfully",
		"clear": "Clear",
		"cloud_provider": "Cloud Provider",
		"cloud_provider_desc":
			"This section allows you to select the cloud provider for your website. The selection you make will determine the availability of certain features in the admin panel.",
		"cloudflare": "Cloudflare",
		"nginx": "Nginx",
		"cloud_provider_modal_title": "Cloud Provider Change",
		"cloud_provider_modal_desc": "Are you sure you want to approve this change?",
		"cloudflare_hover_text":
			"When this option is selected, no changes are made to the admin panel and all features are fully accessible.",
		"nginx_hover_text":
			"Selecting this option will disable the Domains management and the Website Cache inside Dev Tools will become inaccessible.",

		// Cookies
		"cookies": "Cookies",
		"cookies_desc":
			"The website uses cookies for some of the applications. You can activate cookies message for the website, in order to inform site visitors. You can customize the message from admin panel.",

		// Colors
		"colors": "Colors",
		"colors_hint": "https://guide.digitain.com/knowledge-base/branding/#colors",
		"new_set": "New set",
		"colorsets": "Color sets",
		"background_colors": "Background colors",
		"background_color": "Background Color",
		"color": "Color",
		"alignment": "Alignment",
		"brand_colors": "Brand colors",
		"text_colors": "Text and icon colors",
		"reset_colorset": "color set to default",
		"branding": "Branding",
		"color_tab_text": "Website Colors",
		"popups_color_tab_text": "Popup Colors",
		"popups_color_tab_desc": "Please select color mode for the website popups",
		"popups_color_dark": "Dark",
		"popups_color_night": "Night",
		"popups_color_light": "Light",
		"choose_color_mode_default": "Choose Default Color Mode",
		"activate_light_dark_mode": "Activate Light/Dark Modes",
		"deactivate_light_dark_mode": "Deactivate Light/Dark Modes",
		"color_mode_warning_text":
			"Be aware, after activating Light/Dark modes the website will inherit current color set configurations as default color mode. Configurations for other color mode should be done.",
		"color_mode_logos_note": "You can upload invert logos for Light/Dark modes from {name} section.",
		"popups_color_text": "You can set specific mode of popups for each mode",

		// Pages
		"pages": "Pages",
		"pages_hint": "https://guide.digitain.com/knowledge-base/pages/",
		"all_states": "All states",
		"page_name": "Page name",
		"footer_name": "Footer name",
		"created_date": "Created date",
		"edit_content": "Edit content",
		"system": "System",
		"custom": "Custom",
		"alias": "Alias",
		"alias_placeholder_system": "yourdomain.com",
		"alias_page_name": "alias",
		"alias_info": "Alias is the part of the URL that identifies the page related to this Rules menu item.",
		"make_homepage": "Make this your homepage",
		"standart": "Standard",
		"widget_based": "Widget Based",
		"with_header_and_footer": "With header and footer",
		"fullscreen": "Fullscreen",
		"page_name_required": "Page name field is required.",
		"page_name_already_exists": "Page name already exists",
		"page_alias_already_exists": "Page alias already exists",
		"alias_name_required": "Alias field is required.",
		"add_page": "Add a page",
		"page_name_validation_message":
			"Page name can contain 2-30 characters: Latin letters, numbers, spaces and special characters - and _.",
		"alias_name_validation_message":
			"Alias can contain 2-30 characters: latin lowercase letters, numbers, special characters - and _",
		"custom_url_validation_message":
			"Custom URL can contain 2-30 characters: latin lowercase letters, numbers, special characters - and _",
		"delete_page": "Are you sure you want to permanently delete the page?",
		"disable_page":
			"Once you disable a page, it will no longer be accessible on the live website. 404 page will be displayed instead. You can enable the page anytime.",
		"page_delete_success": "Page has been successfully deleted",
		"edit_content_info":
			"Default language content will be displayed on the website in case if there is no content added for a specific language.",
		"last_changed_on": "Last changed on",
		"last_changed_by": "Last changed by",
		"last_changes": "Last Changes",
		"published": "Published",
		"save_and_publish": "Save and Publish",
		"not_published": "Not Published",
		"actions": "Actions",
		"back_to_pages": "Back to page list",
		"include_in_sitemap": "Include in sitemap",
		"all_user_access_page": "All users",
		"authorized_user_access_page": "Only authorized users",
		"session_visibility": "Session Visibility",
		"non_authorized_user_access_page": "Only non-authorized users",
		"access_page_info": "Once enabled, the users will be asked to login in order to access the page.",
		"page_type": "Page type",
		"page_structure": "Page Structure",
		"empty_pages": "You don't have any added pages yet.",
		"empty_search_page": "We couldn't find any pages matching your search.",
		"last_published": "Last published",
		"preview_info": "Only saved changes are available for Preview. You can preview the published content separately.",
		"revisions": "Revisions",
		"current_version": "Current Version",
		"restore_edit": "Restore and Edit",
		"restore_version": "Restore Version",
		"restore_confirm_content":
			"Once you restore this version, all unpublished changes in Current version will be discarded.",
		"print_download_buttons": "Show Print/Download Buttons",
		"homepage_custom_info":
			"The setting retains the main domain when applied to the standard and widget-based custom pages, but changes the main domain for system pages based on the alias.",

		// Popups
		"popups": "Popups",
		"popups_hint": "https://guide.digitain.com/knowledge-base/popups/",
		"popups_alias_info": "Alias is the part of the URL that identifies the created popup.",
		"back_to_popups": "Back to list",
		"back_to_list": "Back to list",
		"popup_name": "Popup name",
		"gridlines": "Gridlines",
		"widgets_outline": "Widgets Outline",
		"widgets_overlap": "Overlap",
		"on_desktop": "Desktop",
		"on_mobile": "Mobile",
		"dark_light_modes": "Light/ Dark Modes",
		"delete_popup": "Are you sure you want to permanently delete the popup?",
		"popup_name_validation_message":
			"Popup name can contain 2-30 characters: Latin letters, numbers, spaces and special characters - and _",
		"popup_alias_name_validation_message":
			"Alias can contain 2-30 characters: latin lowercase letters, numbers and special characters - and _",
		"popup_name_required": "Popup name field is required.",
		"popup_name_already_exists": "Popup name already exists.",
		"popup_alias_already_exists": "Popup alias already exists",
		"popup_upload_image_size_max": "Maximum image file size is 500kb.",
		"empty_popups": "You don't have any added popups yet.",
		"popups_description": "In this section you can add and manage popups for your website.",
		"empty_search_popup": "We couldn’t find any popups matching your search.",
		"add_image_popup": "Please add the image for popup",
		"title_max_chars": "The Title can contain up to 500 characters.",
		"paragraph_max_chars": "The Paragraph text can contain up to 500 characters.",
		"disable_popup":
			"Once you disable a popup, it will no longer be accessible on the live website. You can enable the popup anytime.",
		"popup": "Popup",
		"settings_notification": "Settings apply for all languages",
		"popup_min_size": "Popup minimum size",
		"popup_border_radius": "Popup border radius",
		"delete_advertising": "Delete Advertising",
		"delete_advertising_text": "Are you sure you want to permanently delete the popup?",
		"disable_advertising": "Disable Advertising",
		"image_on_popup": "Image on popup",
		"background_overlay": "Background Overlay",
		"background": "Background",
		"disable_advertising_text":
			"Once you disable a popup, it will no longer be accessible on the live website. 404 page will be displayed instead. You can enable the popup anytime.",
		"paragraph_text": "Paragraph text",
		"title_text_color": "Paragraph text color",
		"text_color": "Title text color",
		"image_overlay_color": "Image Overlay Color",
		"dont_show_again": "“Don’t show again” checkbox",
		"popup_background_color": "Popup background color",
		"content": "Content",
		"paddings": "Paddings",
		"upload_text_1": "Drag and drop here",
		"upload_text_2": "or",
		"upload_text_3": "Click here to Upload",
		"button_name": "Button Name",
		"target_url": "Target Url",
		"business_rule": "Business Rule",
		"warning": "Warning",
		"popup_delete_warning":
			"Be aware that this popup is used in Business rules. After deleting the pop-up, {name}, will not work properly.",
		"popup_disable_warning":
			"Be aware that this popup is used in Business rules. After disabling the pop-up, {name}, will not work properly",
		"activate_mode_warning_msg":
			"Be aware, after activating Light/Dark modes the website will inherit current color set configurations as default color mode. Configurations for second color mode should be done.",
		"deactivate_mode_warning_msg":
			"Be aware, after deactivating Light/Dark modes the website will inherit default mode's color set configurations as website color set. Configurations for second color mode well be saved for future activation.",
		"current_template": "Current Template",
		"project_name": "Project name",

		// Edit Menu
		"SecondaryMenu": "Secondary Menu",
		"MainMenu": "Main Menu",
		"FooterMenu": "Footer Menu",
		"MobileNavBar": "Mobile Navigation Bar",
		"FloatingMenu": "Floating Menu",
		"AccountMenu": "Account Menu",
		"MobileRightMenu": "Mobile Right Menu",
		"FeaturedMenu": "Featured Menu",
		"DesktopNavBarMenu": "Navigation",
		"FeaturedMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#featured-menu",
		"SecondaryMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#secondary-menu",
		"MainMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#main-menu",
		"FooterMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#footer",
		"MobileNavBar_hint": "https://guide.digitain.com/knowledge-base/menus/#mobile-navigation-bar",
		"FloatingMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#floating-menu",
		"DesktopNavBarMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#desktop-navigation",
		"AccountMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#account-menu",
		"MobileRightMenu_hint": "https://guide.digitain.com/knowledge-base/menus/#mobile-right-menu",
		"DesktopNavBarMenu_text":
			"In this section you can manage navigation on your website desktop to arrange horizontal and vertical sections.",
		"headerNavigation": "Header Navigation",
		"sideBarNavigation": "Side Bar Navigation",
		"input_translation_key": "Translation key field is required.",
		"invalid_translation_key":
			"Translation key can contain 2-50 characters: only Latin letters, numbers and special character _",
		"translation_key_already_exists": "Translation key already exists.",
		"input_required_name": "Name field is required.",
		"input_required_url": "URL field is required.",
		"open_in_same_tab": "Open in the same tab",
		"open_in_new_tab": "Open in a new tab",
		"open_in_new_window": "Open in new window",
		"none": "None",
		"new": "New",
		"promotion": "Promotion",
		"calendar": "Calendar",
		"hot": "Hot",
		"top": "Top",
		"free": "Free",
		"premium": "Premium",
		"popular": "Popular",
		"trending": "Trending",
		"cashback": "Cashback",
		"exclusive": "Exclusive",
		"all_languages": "All languages",
		"add_new_menu_item": "Add a new menu item",
		"edit_menu_item": "Edit menu item",
		"edit_menu_items": "Edit Menu Items",
		"add_sub_item": "Add a sub-item",
		"menu_item_delete_confirmation": "Do you want to delete this item?",
		"menu_tab_desktop": "Desktop View",
		"menu_tab_mobile": "Mobile View",
		"menu_tab_general": "General Settings",
		"show_menu_item_icon": "Show menu item icon",
		"show_list_menu_icon": "Show List Menu Icon",
		"show_sidebar_menu_item_icon": "Show sidebar icons",
		"show_banner_section_icon": "Banner section icon",
		"activate_banner_grid": "Activate banner grid",
		"menu_icons": "Menu icons",
		"menu_layout": "Layout",
		"list": "List",
		"linear": "Linear",
		"static_block": "Static Block",
		"expandable_list": "Expandable List",
		"sub_item_view": "Sub-item view",

		"show_on_menu": "Show on Menu",
		"hide_from_menu": "Hide from Menu",
		"unpin_from_header": "Unpin from Header",
		"pin_to_header": "Pin to Header",
		"hidden_from_menu_hint": "The Item is hidden from Menu",

		"nav_bar_icons": "Nav Bar Icons",
		"icon_uploaded": "Icon uploaded successfully",
		"icons_with_text": "Icons with text",
		"only_icons": "Only icons",
		"alternative_view": "Alternative View",
		"menu_font_size": "Menu Font Size",
		"small": "Small",
		"medium": "Medium",
		"font_style": "Menu Font Weight",
		"large": "Big",
		"bold": "Bold",
		"regular": "Regular",
		"font_case": "Menu Font Case",
		"uppercase": "Uppercase",
		"lowercase": "Lowercase",
		"original": "Original",
		"menu_alignment": "Menu alignment",
		"left": "left",
		"center": "center",
		"right": "right",
		"align_left": "Align Left",
		"align_right": "Align Right",
		"align_top": "Align Top",
		"align_bottom": "Align Bottom",
		"align_vertical_center": "Align Vertical Center",
		"align_horizontal_center": "Align Horizontal Center",
		"text_left": "Align Left",
		"text_right": "Align Right",
		"text_center": "Align Center",
		"menu_item_on_mobile": "Show menu item icon in mobile",
		"menu_item_on_desktop": "Show menu item icon in desktop",
		"add_menu_btn_tooltip": `To add an item, please select 'All languages' option from the drop down above.`,
		"settings_btn_tooltip": `To make changes in Settings, please select 'All languages' option from the drop down above.`,
		"hide_show_btn_tooltip": `To show/hide section, please select 'All languages' option from the drop down above.`,
		"hide_show_btn_tooltip2": `To show/hide option, please select 'All languages' option from the drop down above.`,
		"floating_count_validation_msg": `Please input a natural number starting from 1`,
		"product_type": "Product type",
		"product_type_info":
			"By activating any of product types you will be able to configure product specific Mobile Navigation bar for your website.",
		"advanced": "Advanced",
		"switcherPlacement": "Switcher Placement",
		"product_icons_tooltip": "Use a 32x32px ratio for all icons. Supported formats: .png, .webp",
		"product_icons": "Product Icons",
		"upload_new_icon_tooltip": "Upload new icon",
		"reset_to_default_tooltip": "Reset to Default",
		"widget_attention_warning":
			"By switching on the widget, it will not be shown on the website without a configuration in Admin Panel.",

		"badge": "Badge",
		"translation_key": "Translation key",
		"name": "Name",
		"fonts": "Fonts",
		"fonts_hint": "https://guide.digitain.com/knowledge-base/branding/#fonts",
		"main_font": "Main font",
		"font_family": "Font family",
		"choose_font_variation": "Choose specific font variation",
		"font_variation_info":
			"For all languages that are not supported by the custom font, selected web safe font will be used.",
		"header": "Header",
		"footer": "Footer",
		"select_language": "Select language",
		"ask_client": "Suggest Subscription ",
		"activate_age": "Age Confirmation",
		"ask_bonus_offers": "Suggest Bonus Offers",

		"suggest_bonus_offers": "Suggest Bonus Offers",
		"edit_bonus_offers_block": "Edit Bonus Offers block",
		"registration_settings": "Registration Settings",
		"my_profile": "My Profile",
		"my_profile_info":
			'Please mark as "Required" all fields in My profile section that should be filled (or verified in case of Passport/ID, Email and Mobile number) for a player to make a withdrawal.',
		"dashboard": "Dashboard",
		"error": "Error",
		"related_fields_error_message1":
			"Bank Name (list), Account Number and Account Holder name fields all need to be added to the form in order to proceed.",
		"related_fields_error_message3":
			"Bank name and Sheba number fields both need to be added to the form in order to proceed.",
		"related_fields_error_message2":
			"Your Country and City fields both need to be added to the form in order to proceed.",
		"related_fields_error_message4":
			"Please note, that the following 5 fields must be required in both Registration and My profile forms for the service to work correctly: Country, First name, Last name, Passport/ID number, Birthdate.",
		"related_fields_error_message5":
			"Please note, that the following 1 field must be required in both Registration and My profile forms for the service to work correctly: CPF number.",
		"related_fields_error_message6":
			"Document Type and Document Number fields both need to be added to the form in order to proceed.",
		"related_fields_error_message7": "You must add an Email Address field before adding the Confirm Email field.",
		"related_fields_error_message8": "You cannot use both Country/City and the Geolocation control at the same time.",
		"bonus": "Bonus",
		"bonus_campaign": "Bonus Campaign",
		"select_campaign": "Select Campaign",
		"social_media": "Social Media",
		"social_media_hint": "https://guide.digitain.com/knowledge-base/controls/#social-medias",
		"social_media_edit": "Edit Social Media",
		"colored_logos": "Colored Logos",
		"footer_social_desc":
			"Choose social media icons and links that you would like to be displayed in your website's footer.",
		"hide_section": "Hide Section",
		"more": "More",
		"more_hint": "https://guide.digitain.com/knowledge-base/controls/#more",
		"footer_more_desc":
			"Here you can choose the blocks that you would like to be displayed in your website's footer and edit their information.",
		"show": "Show",
		"show_section": "Show Section",
		"login_type_description": "Show inline in header (for desktop)",
		"login_field_type": "Login Field Type",
		"copyright_validation_msg": "Maximum length for the copyright information is 100 characters.",
		"edit_terms_and_conditions_block": "Edit Terms and Conditions block",
		"edit_subscribtions_block": "Edit Subscriptions block",
		"menu_item_icon": "Menu item icon",
		"menu_icon_tooltip": "The icon will be displayed on all device types where it is enabled",
		"fproduct_icon_tooltip": "The icon will be displayed on all device types where it is enabled",
		"show_menu": "Show Menu",
		"menu_hidden_title": "This Menu is Currently Hidden.",
		"menu_hidden_text": 'Switch "Show Menu" toggle to on to unhide this menu.',
		"hide_show_menu_btn_tooltip": `To show/hide menu, please select 'All languages' option from the drop down above.`,
		"promotion_menu_item_tooltip": "Go to Promotions section to add highlights.",
		"login_with_passkey_description": "Login with Passkey",
		"pinned": "Pinned",
		// Roles
		"roles_all_language_txt": "Please choose a specific language to edit content",
		"roles_empty_menu": "You can add Rules page content once there are menu items added",
		"roles_menu_add_txt": "Please add menu items here. Later you can also add sub-menu items.",
		"add_menu_item": "Add a menu item",
		"full_width_content": "Full width content",
		"rules_alias_info": "Alias is the part of the URL that identifies the page related to this Rules menu item.",

		// Form Creation
		"recover_password": "Recover Password",
		"timezone": "Date And Time",
		"timezone_hint": "https://guide.digitain.com/knowledge-base/controls/#timezone",
		"sign_in": "Sign In",
		"wizard": "Wizard",
		"page": "Page",
		"column": "Column",
		"inventory": "Inventory",

		"Button": "Button",
		"Captcha": "Captcha",
		"Title": "Title",
		"TextBox": "Text Box",
		"Radio": "Radio",
		"Checkbox": "Checkbox",
		"Select": "Drop down menu",
		"Datepicker": "Date picker",
		"Link": "Link",
		"Image": "Image",
		"ImageAlt": "Image Alt",
		"Switch": "Switch",
		"LinkButton": "Link button",
		"add_control_dragger_message": "To add control drag and drop it here",
		"chooseFieldType": "Choose field type",
		"drop_down": "Drop Down",
		"country_code": "With country code",
		"drop_down_menu": "Drop Down Menu",
		"radio_button": "Radio Button",
		"single_choice": "Single Choice",
		"multiple_fields": "Multiple Fields",

		// Timer control
		"secondary_left": "Secondary menu bar - Left side",
		"secondary_right": "Secondary menu bar - Right side",
		"main_left": "Main menu bar - Left side",
		"main_right": "Main menu bar - Right side",
		"show_time_zone": "Show time zone",
		"time_zone": "Timezone",
		"time_and_time_zone": "Time and Timezone",
		"show_date": "Show Date",
		"date_format": "Date Format",

		// Create Project
		"get_started": "Get started",
		"site_name": "Site name",
		"choose_name": "Provide site details",
		"choose_template": "Choose your template",
		"creating_website": "Creating a website",
		"site_already_exists": "This site name already exists.",
		"creating_domain_msg": "Creating domain for your web site.",
		"creating_website_msg": "Please wait while we are creating your website, this may take a few minutes.",
		"default_currency": "Default currency",
		"default_currency_info":
			"The currency will be used as a basis for currency conversions in multiple widgets and features. Selected currency cannot be edited in the future and will not affect currencies added for the website.",

		// Corner Radius
		"corner_radius": "Corner Radius",
		"left_bottom": "Left Bottom",
		"right_bottom": "Right Bottom",
		"right_top": "Right Top",
		"left_top": "Left Top",
		"all_corners": "All Corners",
		"input_fields": "Inputs and Dropdowns",
		"buttons": "Buttons",
		"buttons_hint": "https://guide.digitain.com/knowledge-base/branding/#buttons",
		"input_fields_hint": "https://guide.digitain.com/knowledge-base/branding/#inputs-and-dropdown",

		// Icon set
		"icon_sets": "Icon Sets",
		"icon_sets_hint": "https://guide.digitain.com/knowledge-base/branding/#icon-sets",
		"outline_icons": "Outline Icons",
		"filed_icons": "Filled Icons",
		"icon_hover_state": "Icon Hover State",
		"icon": "Icon",

		// Footer
		"copyright_text": "Digitain. All rights reserved.",
		"social_medias": "Social Media",
		"payment_methods": "Payment Methods",
		"payment_methods_hint": "https://guide.digitain.com/knowledge-base/controls/#payment-methods",
		"menus": "Menus",
		"images": "Images",
		"custom_ui_keys": {
			CustomerSupport: "Customer Support",
			AgeRestriction: "Age Restriction",
			CopyRightInfo: "Copyright Info",
			// PoweredByDigitain: 'Powered By Digitain',
			AboutCompany: "About Company",
			MobileApps: "Mobile Apps",
			Language: "Language dropdown",
		},

		"languageSpecificEditDescription": "Choose a specific language to edit the description.",

		"image_block": "Image Block",
		"story_block": "Story Block",

		// Announcement
		"announcment": "Announcement",
		"announcment_hint": "https://guide.digitain.com/knowledge-base/controls/#announcement",
		"announcment_empty_title": "This Section is Currently Empty. ",
		"announcment_empty_text": "In this section you can add and manage announcements for your website.",
		"announcment_add": "Add Announcement",
		"announcment_create_btn_tooltip":
			"To add an Announcement, please select 'All languages' option from the drop down above.",
		"announcment_edit": "Edit Announcement",
		"announcment_delete_confirmation": "Are you sure you want to delete {name} from Announcement?",
		"announcment_permanent": "Make Announcement permanent",
		"announcment_name_already_exists": "Name already exists",
		"announcment_invalid_name":
			"Name can contain 2-30 characters: only Latin letters, numbers and special character _.",
		"empty_search_announcments": "We couldn’t find any announcements matching your search.",

		// App Adviser
		"app_advisor": "App Adviser",
		"app_name": "Application name",
		"app_name_hint": "The Application name is not translatable.",
		"add_app_name": "Add application name",
		"app_name_required_message": "Please input application name",
		"app_general_url": "One General URL",
		"app_ios_url_placeholder": "Enter App Store URL here",
		"app_android_url_placeholder": "Enter Play Store URL here",
		"app_general_url_placeholder": "Enter URL",
		"app_url_validation": "Please enter URL",
		"app_section_switch_text": "Mobile App Download Suggestion",
		"app_logos_note": " You can upload logo for Application from {name} section.",
		"app_advisor_text":
			"Here you can activate the pop-up on mobile to suggest downloading mobile apps. You should enter at least one URL",
		"app_name_validation_message":
			"Application name can contain 2-50 characters: letters, numbers, spaces and special characters - and _.",
		"app_advisor_hint": "https://guide.digitain.com/knowledge-base/controls/#app_advisor",

		// Mobile App Link
		"mobile_apps": "Mobile Apps",
		"mobile_apps_text": "Here you can add links for downloading mobile apps. You should enter at least one URL.",
		"mobile_apps_url_validation": "Please enter URL",
		"mobile_apps_hint": "https://guide.digitain.com/knowledge-base/controls/#mobile-apps",

		// Banners
		"banners_description":
			"Recommended image size in this section is {width}x{height}px. You can upload .jpg, .gif, .png, .webp images. In order to maintain best image quality, upload images in a .webp format.",
		"banners_description_withNote":
			"Recommended banner size: {width}x{height}. Note: Banner height is dynamic and will be fitted depending on the number of form fields in the column.",
		"banners_description_registration_alternative":
			"Recommended image sizes for this section are 328x90px for 1 column, 658x90px for 2 columns, and 992x90px for 3 columns. You can upload .jpg, .gif, .png, .webp images. In order to maintain best image quality, upload images in a .webp format.",
		"home_page_main_section": "Top",
		"home_page_secondary_section": "Secondary",
		"home_page_top_casino_games_section": "Top Casino Games",
		"home_page_featured_banner_section": "Featured Banner",
		"home_page_recommended_section": "Recommended Games",
		"home_page_top_live_casino_games_section": "Top Live casino games",
		"home_page_top_tv_games": "Top TV Games",
		"home_page_top_virtual_sport": "Top Virtual Sport",
		"home_page_top_small_banner_section": "Top small",
		"home": "Home",
		"casino_page": "Casino page",
		"casino_page_main_section": "Top",
		"casino_lobby_page_main_section": "Top",
		"livecasino_page_main_section": "Top",
		"casino_tournaments_page_main_section": "Top",
		"tvgames_page_main_section": "Top",
		"virtualsport_page_main_section": "Top",
		"fastgames_page_main_section": "Top",
		"myprofile_popup": "Popup banners",
		"myprofile_popup_main_section": "Top",
		"registration_popup_main_section": "Top",
		"join_popup_main_section": "Top",
		"login_popup_main_section": "Top",
		"casino_home_secondary_section": "Secondary",
		"live_casino_home_secondary_section": "Secondary",
		"tv_games_home_secondary_section": "Secondary",
		"virtual_sport_home_secondary_section": "Secondary",
		"fast_games_home_secondary_section": "Secondary",
		"casino_home_main_section": "Top",
		"livecasino_home_main_section": "Top",
		"tvgames_home_main_section": "Top",
		"virtualsport_home_main_section": "Top",
		"fastgames_home_main_section": "Top",
		"sport_page_top_section": "Top Games",

		"login_page_main_section": "Top",
		"login_page_side_section": "Side",
		"registration_page_main_section": "Top",
		"registration_page_side_section": "Side",
		"banner_delete_confirmation": "Are you sure you want to permanently delete the banner?",
		"banner_delete_success": "Banner has been successfully deleted",
		"banner_enabled_success": "Banner has been successfully enabled",
		"banner_disabled_success": "Banner has been successfully disabled",
		"banner_grid_empty_title": "You don’t have banner section yet",
		"banner_grid_empty_text": "You can add banner section by clicking plus button",
		"add_banner_section": "Add Banner Section",
		"no_end_date": "No End Date",
		"upload_image_size_max": "Maximum image size is 500kb.",
		"upload_image_size_max_500": "Maximum image file size is 500kb.",
		"upload_image_block_size_max": "Maximum image size is 250 KB.",
		"stories_block_size_max": "Maximum image size is 100kb.",
		"display_mode": "Display Mode",
		"fill_bounding_box": "Fill bounding box",
		"fit_bounding_box": "Fit bounding box",
		"image_delete_confirmation": "Are you sure you want to permanently delete the image?",
		"image_delete_success": "Image has been successfully deleted",

		// Robots
		"robots": "Robots",
		"robots_hint": "https://guide.digitain.com/knowledge-base/robots/",
		"robots_description": "Manage robots.txt file for your domains",
		"robots_save_success": "Robots.txt has been saved successfully",
		"robots_save_error": "Failed to save robots.txt",
		"robots_load_error": "Failed to load robots.txt content",
		"robots_editor_hint": "Valid directives: User-agent, Allow, Disallow, Sitemap, Crawl-delay, Host",
		"validation_errors": "Validation Errors",
		"validation_warnings": "Warnings",
		"quick_insert": "Quick insert",
		"last_updated_at": "Last Updated At",
		"last_updated_by": "Last Updated By",
		"created_at": "Created At",
		"robots_hint_user_agent": "Specifies which bots the rules apply to.",
		"robots_hint_disallow": "Tells bots not to crawl certain pages or directories.",
		"robots_hint_allow": "Overrides a Disallow rule for a specific page or directory.",
		"robots_hint_allow_note": "Here, bots cannot crawl /blog/ except for /sport/ category",
		"robots_hint_sitemap": "Points search engines to the sitemap file location.",
		"robots_hint_crawl_delay": "Sets the delay (in seconds) between successive crawl requests.",

		// News Blog - Articals
		"news_blog": "News / Blog",
		"articles": "Articles",
		"news_blog_hint": "https://guide.digitain.com/knowledge-base/news-blog/",
		"news_blog_description": "In this section you can add and manage news for your website.",
		"empty_articles":
			"You don’t have any added Articles yet. Before adding an Article please make sure that you have added at least one ",
		"article_add_btn_tooltip": 'To add an article, please select "All languages" option from the drop down above.',
		"add_article": "Add Article",
		"news_title_tooltip":
			"This title will be displayed on the website in case if there is no News title added for a specific language.",
		"news_title_required_message": "News title field is required.",
		"news_title_validation_message":
			'News title can contain 2-75 characters: letters, spaces numbers and special characters excluding " \\ [] ',
		"news_category_field_required_message": "Please select a category for the news",
		"news_url_required_message": "News URL field is required.",
		"news_article_url_already_exists": "News with the provided url already exists.",
		"choose_news_category": "Choose news category",
		"publisher": "Publisher",
		"publisher_placeholder": "Enter the publisher name here",
		"publish_date": "Publish Date",
		"news_publisher_validation_message":
			'News publisher name can contain 2-50 characters: letters, spaces numbers and special characters excluding " \\ [] ',
		"read_time": "Read Time",
		"read_time_placeholder": "Enter read time here",
		"read_time_validation_message": "Please enter a number between 1 and 99",
		"article_card": "Article Card",
		"artiicle_detailed_info_page": "Detailed Info Page",
		"search_by_news": "Search by news",
		"general_news_label": "Homepage",
		"casino_news_label": "Casino Lobby and Home",
		"sport_news_label": "Sports",
		"news_img_required_message": "Please add the image for Article Card",
		"empty_category_desc":
			"In this section you can add and manage categories for your articles. Click “Add a New One” to see all the options available.",
		"blog_category_name_desc": "This name will be displayed on the website in the category path.",
		"blog_category_delete_confirmation": "Are you sure you want to permanently delete the article category?",
		"blog_category_delete_success": "Article category has been successfully deleted",

		"news_delete_confirmation": "Are you sure you want to permanently delete the news?",
		"news_delete_success": "News has been successfully deleted",
		"news_enabled_success": "News has been successfully enabled",
		"news_disabled_success": "News has been successfully disabled",
		"guide": "https://guide.digitain.com",
		"news_add_btn_tooltip": 'To add an article, please select "All languages" option from the drop down above.',

		// Promotions
		"promotions": "Promotions",
		"promotionCategories": "Promotion categories",
		"rules": "Rules",
		"promotions_hint": "https://guide.digitain.com/knowledge-base/promotions/",
		"promotions_description": "In this section you can add and manage promotions for your website.",
		"all_promotions": "All promotions",
		"empty_promotions":
			"You don’t have any added promotions yet. Before adding a promotion please make sure that you have added at least one ",
		"promotion_type": "Promotion Type",
		"promotion_delete_success": "Promotion has been successfully deleted",
		"promotion_enabled_success": "Promotion has been successfully enabled",
		"promotion_disabled_success": "Promotion has been successfully disabled",
		"hide_from_promotions": "Hide from Promotions",
		"calendar_page_preview": "Preview as Calendar Page",
		"categories_hint": "https://guide.digitain.com/knowledge-base/promotions/#categories",
		"promotion_settings": "Card View On Mobile:",
		"overlay_info": "Overlay Info",
		"bottom_info": "Bottom Info",
		"promotionRecurring": "Recurring",

		"add_promotion": "Add Promotion",
		"edit_promotion": "Edit Promotion",
		"choose_promotion_category": "Choose promotion category",
		"detailed_info": "Detailed info",
		"detailed_info_page": "Detailed info page",
		"page_link": "Page Link",
		"img_alt_name": "Image alt name",
		"add_button": "Action button",
		"action_button_name": "Action button name",
		"separate_landing_page": "Separate page",
		"separate_full_page": "Full page",
		"search_by_promotions": "Search by promotions",
		"highlight": "Highlight",
		"highlighted": "Highlighted",
		"not_highlighted": "Not Highlighted",
		"remove_highlight": "Remove Highlight",
		"select_target_page": "Select Target Page",

		"reset_filters": "Reset Filters",
		"bulk_action": "Bulk Action",
		"selected_items": "Selected items",
		"archive_txt":
			"Once you archive a promotion it will no longer be displayed on the website. Please confirm the action.",
		"archive": "Archive",
		"name_tooltip":
			"This name will be displayed on the website in case if there is no Promotion name added for a specific language.",
		"action_button_tooltip":
			"This name will be displayed on the button in case there is no button name added for a specific language.",

		"promotion_img_required_message": "Please add the default image for the promotion",
		"img_alt_name_validation":
			'Image alt name can contain up to 125 characters: letters, spaces, numbers and special characters, excluding " \\ [] ',
		"promotion_name_required_message": "Promotion name field is required.",
		"promotion_name_validation_message":
			'Promotion name can contain 2-50 characters: letters, spaces numbers and special characters excluding " \\ [] ',
		"category_field_required_message": "Please select a category for the promotion",
		"campaign_field_required_message": "Campaign field is required",
		"button_name_validation": "Button name can contain 1-20 characters: letters, spaces and numbers.",
		"button_name_required_message": "Button name field is required.",
		"page_link_required_message": "Page link field is required.",
		"url_required_message": "URL field is required.",
		"promotion_delete_confirmation": "Are you sure you want to permanently delete the promotion?",

		"promotion_category_disabled_success": "Promotion category has been successfully disabled",
		"promotion_category_delete_success": "Promotion category has been successfully deleted",
		"promotion_category_enabled_success": "Promotion category has been successfully enabled",
		"promotion_category_delete_confirmation": "Are you sure you want to permanently delete the promotion category?",
		"promotion_category_add_btn_tooltip":
			'To add a category, please select "All languages" option from the drop down above.',
		"promotion_add_btn_tooltip": 'To add a promotion, please select "All languages" option from the drop down above.',
		"promotion_short_description": "Short description",
		"promotion_short_description_validation":
			'Promotion short description can contain 2-150 characters: letters, spaces, numbers and special characters excluding " \\ [] ',

		"archive_confirmation":
			"Once you archive a promotion it will no longer be displayed on the website. Please confirm the action.",
		"promotion_archive_success": "Promotion has been successfully archived",
		"archive_description":
			"Here you can see archived promotions. They are not displayed on website regardless their start and end dates.",
		"restore_promotion": "Are you sure you want to restore the promotion?",
		"promotion_restore_success": "Promotion has been successfully restored",
		"deposit": "Deposit",
		"common_required": "Please input {name}",
		"archive_promotions":
			"Here you can see archived promotions. They are not displayed on website regardless their start and end dates.",

		"empty_search_promotion": "We couldn’t find any promotions matching your search.",
		"empty_search_banner": "We couldn’t find any banners matching your search.",
		"empty_search_story": "We couldn’t find any stories matching your search.",
		"empty_search_image_set": "We couldn’t find any images matching your search.",
		// Categories
		"category": "Category",
		"categories": "Categories",
		"all_categories": "All categories",
		"add_category": "Add Category",
		"edit_category": "Edit Category",
		"choose_an_icon": "Choose an icon",
		"allIcons": "All",
		"gameIcons": "Game",
		"socialMediaIcons": "Social Media",
		"otherIcons": "Other",
		"category_short_description_validation":
			'Category short description can contain 2-150 characters: letters, spaces, numbers and special characters excluding " \\ [] ',

		"category_name": "Category Name",
		"category_icon": "Category icon",
		"category_name_validation_message": "Category name can contain 2-50 characters: only letters, spaces and numbers.",
		"category_name_required_message": "Category name field is required.",
		"category_icon_required_message": "Please select a category icon",
		"category_add_decs": 'To add a category, please select "All languages" option from the drop down above.',
		"category_name_desc":
			"This name will be displayed on the website in case if there is no Category name added for a specific language.",
		"category_name_short_desc": "This description will appear on the Calendar page below the category name.",
		"replace_promotion_category": "Replace all fields values for all languages with these default values",
		"empty_promotion_category":
			"In this section you can add and manage categories for your promotions. Click “Add a New One”to see all the options available.",
		"category_name_already_exists": "Category with provided name already exists.",
		"category_url_already_exists": "Category with provided url already exists.",
		"more_icons": "More Icons",

		// Provider
		"providers": "Providers",
		"providers_hint": "https://guide.digitain.com/knowledge-base/controls/#providers",
		"footer_providers_desc":
			"Choose casino providers that you would like to be displayed in your website's footer. You can switch between colored and monochrome versions of the logo.",
		"provider_delete_confirmation": "Are you sure you want to delete {name} from footer?",
		"add_provider": "Add Provider",
		"edit_provider": "Edit Provider",
		"add_provider_btn": "To add a Provider, please select 'All languages' option from the drop down above.",

		// License
		"licenses": "Licenses",
		"license_type": "Licenses Type",
		"license_body": "Licensing Body",
		"seal_id": "Seal ID",
		"license_description":
			"Select license type, licensing body, input seal ID provided by the licensing body and choose under which domains the license script should be added. By default the license script will be added for all domains of your website.",
		"add_more": "Add More",
		"section_empty_title": "This Section is Currently Empty",
		"section_empty_text": 'Click "Add a New One" to see all the options available.',
		"add_a_new_more": "Add a new more",
		"section_hidden_title": "This Section is Currently Hidden.",
		"section_hidden_text": 'Switch "Show Section" toggle to on to unhide this section.',
		"logo": "Logo",
		"license": "License",
		"license_domain_required": "Please select at last one domain",
		"license_seal_id_required": "Please input Seal ID",
		"license_body_required": "Please select Licensing Body",
		"licenses_domain_tooltip": "Please select under which domains the license script should be added.",
		"licenses_main_domain": "Main Domain",
		"licenses_main_domain_tooltip":
			"Please input the domain to be used in the license script. If no main domain is added, domain parameter value in the script will depend on the domain that the website is opened with.",

		// Refer a Friend
		"refer_a_friend": "Refer a Friend",
		"refer_a_friend_desc":
			"Please specify period in hours for which you want to keep the referrer's ID information for new registrations on the website.",
		"refer_a_friend_hours_restriction": "Please specify a whole number between 0 and 720",

		// Featured Producds
		"featured_product_limit_msg":
			"Maximum number of featured products for your website is reached, you can only replace existing ones",
		"featured_product_description": "Choose featured products that you would like to be displayed on your website.",
		"featured_product": "Featured Products",
		"featured_product_hint": "https://guide.digitain.com/knowledge-base/controls/#featured-products",
		"featured_product_delete_confirmation": "Are you sure you want to delete {name} from featured products?",
		"featured_products_add": "Add Featured Products",
		"featured_product_icon": "Featured Products icon",
		"featurd_product_list": "Featured product list view",
		"featurd_product_style": "Featured product style",
		"featured_product_size": "Featured product size",
		"grid": "Grid",
		"slider": "Slider",
		"classic": "Classic",
		"blues": "Blues",
		"pop": "Pop",
		"rock": "Rock",

		// Access Buttons
		"access_buttons": "Access Buttons",
		"access_buttons_hint": "https://guide.digitain.com/knowledge-base/controls/#access-buttons",
		"access_buttons_text": "Choose the way Registration and Login buttons are displayed on the website.",
		"registr_login": "Registration and Login",
		"only_registr": "Only Registration",
		"only_login": "Only Login",
		"join": "Join",
		"show_buttons": "Show buttons",
		"type_buttons": "Type",
		"standard_with_icon": "Standard with Icon",
		"only_text": "Only Text",
		"only_icon": "Only Icon",

		// Payment Method Controls
		"payment_methods_desc":
			"Choose payment methods that you would like to be displayed in your website's footer. You can switch between colored and monochrome versions of the logo.",
		"delete_payment_method": "Are you sure you want to delete {name} payment method from footer?",
		"add_payment_method_btn": "To add a Payment Method, please select 'All languages' option from the drop down above.",
		"payment_methods_empty_text":
			"You don’t have any added payment methods yet. Click “Add a New One” to see all the options available.",
		"providers_empty_text":
			"You don’t have any added providers yet. Click “Add a New One” to see all the options available.",

		// banner pages
		"Mainpage": "Main Page",
		"MyProfile": "My Profile",
		"CasinoPage": "Casino page",
		"Casino": "Casino",
		"LiveCasinopage": "Live Casino",
		"TVGamespage": "TV Games",
		"VirtualSportpage": "Virtual Sport",
		"FastGames": "Fast Games",
		"Registration": "Registration",
		"Login": "Login",
		"Join": "Join",
		"CasinoTournaments": "Casino Tournaments",
		"CasinoHome": "Casino Home",
		"LiveCasinoHome": "Live Casino Home",
		"TVGamesHome": "TV Games Home",
		"VirtualSportHome": "Virtual Sport Home",
		"FastGamesHome": "Fast Games Home",
		"LoginPage": "Login Page",
		"RegistrationPage": "Registration Page",
		"LoginPopup": "Login Popup",
		"RegistrationPopup": "Registration Popup",

		// rules
		"rule_name_validation_message":
			"Menu name can contain 2-50 characters including Latin letters, numbers and special characters - and _",
		"rule_name_required": "Menu name field is required",
		"rule_ls_name_validation_message": "Menu name can contain 2-50 characters",
		"content_details": "Content details",

		// Business rules
		"create_first_bussines_rule": "Start to Create Your First Rule",
		"business_rule_details": "Rule details",
		"business_rule_section_desc":
			"In this section you can set automate rules to show event-based custom pop-ups or to manage navigation on your website.",
		"business_rule_name_validation_message":
			"Rule name can contain 2-30 characters, including Latin letters, numbers and spaces.",
		"business_rule_description_validation_message":
			"Rule description can contain 2-150 characters, including Latin letters, numbers, special characters and spaces",
		"business_rule_name_required_message": "Please input business rule name",
		"business_rule_name": "Rule name",
		"business_rule_exists": "Rule with this name already exists.",
		"business_rule_description": "Rule description",
		"BussinesRules_hint": "https://guide.digitain.com/knowledge-base/business-rules/",
		"add_busines_rule": "New business rule",
		"business_rules": "Business Rules",
		"business_rules_empty_text": "You don't have any added busines rules yet",
		"business_rules_search": "Search by Rule name",
		"business_rules_enabled_success": "Business rule has been successfully enabled",
		"business_rules_disabled_success": "Business rule has been successfully disabled",
		"trigger": "Trigger",
		"add_trigger": "Add Trigger",
		"business_rules_add": "Add New Rule",
		"business_rules_name": "Rule Name",
		"last_update": "Last Update",
		"action": "Action",
		"value": "Value",
		"condition": "Condition",
		"draft": "Draft",
		"all_triggers": "All Triggers",
		"back_to_rule_list": "Back to Rules List",
		"trigger_change_confirmation_title": "Are you sure you want to change the trigger?",
		"trigger_step_description":
			"Triggers start execution of a rule. You can choose only one trigger for a specific rule.",
		"trigger_change_confirmation_desc": "Any configured action(s) or condition(s) will be reset.",
		"business_rule_edit_before_leave_msg": "Are you sure you want to leave without saving changes?",
		"business_rule_action_delete_confirmation": "Are you sure you want to delete the action?",
		"business_rule_condition_delete_confirmation": "Are you sure you want to delete the condition?",
		"save_rule_as_draft": "Save as draft",
		"discard_changes": "Discard changes",
		"back_busines_rules_confirmation_title": "Are you sure you want to go back to Rule list?",
		"back_busines_rules_confirmation_desc": "The rule is not configured completely. How do you want to proceed?",
		"back_busines_rules_confirmation_desc1": "The rule is configured. How do you want to proceed?",
		"add_component": "Add component",
		"add_component_description":
			"You can specify additional conditions to be checked for the rule or you can select an action and finish the rule setup.",
		"add_condition_optional": "Add Condition (optional)",
		"add_condition_optional_description": "Make the rule more specific and targeted for your audience.",
		"add_condition": "Add Condition",
		"add_condition_description": "Action will be executed only if the specifed condition are met.",
		"add_action": "Add Action",
		"add_action_description": "Select an action to be executed when the rule conditions are met.",
		"back_to_components": "Back to components ",
		"save_condition": "Save Condition",
		"save_business_rule_changes": "Save Rule Changes",
		"save_busines_rule": "Save Rule",
		"edit_busines_rule": "Edit Rule",
		"popup_url": "Popup URL",
		"when": "When",
		"then": "Then",
		"if": "If",
		"and": "And",
		"second": "Second",
		"hour": "Hour",
		"day": "Day",
		"week": "Week",
		"month": "Month",
		"PageOpenTrigger": "User opens a page/popup",
		"PageOpenTriggerInfo": "The rule starts executing once the user navigates to a page or to a popup.",
		"EnterWebsiteTrigger": "User enters the website",
		"EnterWebsiteTriggerInfo":
			"The rule starts executing once the user opens the website (no matter on which page - popups like Login, Registration, etc. do not count).",
		"LoginTrigger": "User logs in",
		"LoginTriggerInfo": "The rule starts executing once the user logs into his/her account.",
		"LogoutTrigger": "User logs out",
		"LogoutTriggerInfo": "The rule starts executing once the user logs out from his/her account.",
		"SignUpTrigger": "User signs up",
		"SignUpTriggerInfo": "The rule starts executing once the user registers on website successfully.",
		"PageURLCondition": "Page URL",
		"DeviceTypeCondition": "User's device type",
		"LocationCondition": "User's location",
		"AuthorizationStatusCondition": "Visitor's status",
		"VerificationStatusCondition": "User's verification status",
		"AccountStatusCondition": "User's Account Status",
		"PageURLConditionInfo": "Specify the page (s) of the website where the user is on.",
		"DeviceTypeConditionInfo": "Choose the user's device type.",
		"LocationConditionInfo": "Specify the country (country list) where the user is located.",
		"AuthorizationStatusConditionInfo": "Specify if the user needs to be authorized/non-authorized on the website.",
		"VerificationStatusConditionInfo": "Choose the user's data (email,mobile,document) verification status.",
		"AccountStatusConditionInfo":
			"Specify the user's account status that must be matched for this business rule to apply.",
		"AccountStatusActive": "Active",
		"AccountStatusBlockSportsbook": "Block For Sportsbook",
		"AccountStatusBlockCasino": "Block For Casino",
		"AccountStatusBlockWithdrawals": "Block For Withdrawals",
		"AccountStatusBlockTransactions": "Block For Transactions",
		"AccountStatusBlockDeposits": "Block For Deposits",
		"AccountStatusBlockUnverified": "Block For Unverified",
		"ShowPopupAction": "Show Popup",
		"ShowPopupActionInfo": "Specify the popup URL that should open.",
		"NavigateToAction": "Navigate to",
		"NavigateToActionInfo": "Specify the URL that user should be redirected to.",
		"rule_delete_confirmation_text": "Are you sure you want to delete the rule?",
		"business_rule_popupList": "Popup name",
		"business_rule_delay": "Action delay time (sec.)",
		"business_rule_maxCount": "Action iteration quantity",
		"business_rule_period": "Action period",
		"business_rule_url": "URL",
		"business_rule_label_popupList": "Select the popup that should open",
		"delayCountValidationMessage": "Please specify a whole number between 0 and 86400.",
		"maxCountValidationMessage": "Please specify a whole number between 0 and 200.",
		"urlValidationMessage": "Please insert valid URL.",
		"textvalidationMessage": "Please input text.",

		// widgets
		"widgets_panel": "Widgets Panel",
		"footer_management": "Footer Management",
		"footer_managment_hint": "https://guide.digitain.com/knowledge-base/footer-management/",
		"header_management": "Header Management",
		"footer_name_validation_message":
			"Footer name can contain 2-30 characters: Latin letters, numbers, spaces and special characters - and _.",
		"footer_name_required_message": "Footer name field is required.",
		"duplicate": "Duplicate",
		"rename": "Rename",
		"duplicate_name": 'Duplicate "{name}"',
		"rename_name": 'Rename "{name}"',
		"set_as_current": "Set as Current",
		"manage_footer": "Manage Footer",
		"delete_widget": 'Delete "{name}"',
		"delete_widget_conf": "Are you sure you want to delete this footer?",
		"widget_name_already_exists": "Footer name already exists.",
		"blank_footer": "Blank Footer",
		"template_name": "Default Template",
		"add_footer": "Add a footer",
		"choose_template_footer": "Choose Template",
		"current": "Current",
		"timer": "Timer",
		"countdown": "Countdown",
		"useNativeColors": "Use Icons native colors",
		"hoverStateText": "You can adjust element behavior by adding hover state",
		"itemText": "Item",
		"blankWidgetTitle": `No data available`,
		"sportsBookBlank": `The Sports Products on your platform are currently inactive. To activate them, please navigate to Sport Settings.`,
		"storyBlank": `The Story Block isn't configured`,
		"addContent": "Manage",
		"sport": "Sport",
		"mobileDisplayType": "Display type in mobile",
		"other": "Other",
		"lobby": "Lobby",
		"divider_title": "Divider",
		"divider": "Divider",
		"borderWidth": "Weight",
		"solid": "Solid",
		"dashed": "Dashed",
		"dotted": "Dotted",
		"divider_style": "Style",
		"customtext": "Custom Text",
		"htmlblock": "HTML Block",
		"registrationform": "Registration",
		"channels": "Channels",
		"paymentmethods": "Payment Methods",
		"dock_right": "Dock To Right",
		"undock_sidebar": "Undock Sidebar",
		"differences_popup_title": "Desktop and Mobile Display Differences",
		"differences_popup_desc":
			"Changes you make may look different on Desktop and Mobile. Please review and edit the devices separately to ensure your content displays correctly.",
		"html_block": "HTML Block",
		/* Footer */

		"secondarylanguagebar": "Language Bar",
		"socialmedia": "Social Media",
		"mobileapps": "Mobile Apps",
		"aboutcompany": "About Company",
		"agerestriction": "Age Restriction",
		"separator": "Separator",
		"poweredbydigitain": "Powered by Digitain",
		"imageblock": "Image Block",
		"customersupport": "Customer Support",
		"scrolltotop": "Scroll To Top",
		"topmatches": "Top Matches Total",
		"topwinnerswidget": "Top Winners Widget",
		"topwinners": "Top Winners",
		"topjackpotswidget": "Jackpot",
		"copyright": "Copyright",
		"featuresproducts": "Featured Products",
		"featuredmenu": "Featured Menu",
		"copyrightinfo": "Copyright Info",
		"livetopmatches": "Live Top Matches",
		"prematchtopmatches": "Top Matches",
		"multibetOfTheDay": "Multibet of the Day",
		"superPromotions": "Super Promotions",
		"liveandprematch": "Live And Prematch",
		"sportjackpot": "Sport Jackpot",
		"casinomostliked": "Most Liked Widget",
		"recentlyplayedgames": "Recently Played Games",
		"design": "Design",
		"paddingLeft": "Left",
		"paddingRight": "Right",
		"gap": "Gap",
		"paddingTop": "Top",
		"paddingBottom": "Bottom",
		"elementSpacing": "Gap",
		"spacings": "Spacings",
		"footermenu": "Footer Menu",

		"editTopWinner": "Edit Top Winners",
		"chooseProducts": "Choose Products",
		"top_winners_hidden_text": "The Top Winners is not configured for the Lobby Pages.",

		// story management
		"story": "Story",
		"block_name": "Block name",
		"story_name_tooltip":
			"This name will be displayed on the website in case there is no Block name added for a specific language.",
		// logo alignment
		"logo_alignment_text": "Logo alignment on mobile",

		// SEO rules
		"seo_rules": "SEO Rules",
		"seo_rules_enable": "Enable SEO Rules",
		"seo_settings_attention": "The section is currently inactive",
		"seo_settings_attention_warning":
			"This section is not active when the SEO Rules section is enabled. Disable the SEO Rules section first if you would like this content to be reflected in search engines.",
		"seo_rules_hint": "https://guide.digitain.com/knowledge-base/seo-rules/",
		"seo_rules_section_title": "SEO Rules",
		"seo_rule_section_description": "In this section you can set and manage SEO content  for your website.",
		"create_first_seo_rule": "Start to Create your first Rule",
		"seo_rules_empty_text": "You don't have any added SEO rule yet.",
		"add_seo_rule": "New SEO Rule",
		"seo_rule_name": "Rule name",
		"seo_rule_name_validation_message":
			"Rule name can contain 2-30 characters, including Latin letters, numbers and spaces.",
		"seo_rule_name_required": "Rule name field is required.",
		"seo_rule_name_already_exists": "Rule name already exists.",
		"seo_rule_value_validation": "Character limit is 500",
		"value_required": "Value field is required.",
		"operator": "Operator",
		"meta_content": "Meta Content",
		"block_content": "Block Content",
		"add_block": "Add Block",
		"block": "Block",
		"seo_block_delete_confirmation_text": "Are you sure you want to delete the block from Block Content?",
		"seo_rule_block_unsaved_changes":
			"You haven't saved changes in Block Content section. Are you sure you want to navigate to other section?",
		"seo_rule_meta_unsaved_changes":
			"You haven't saved changes in Meta Content  section. Are you sure you want to navigate to other section?",
		"seo_rule_go_back_unsaved_changes":
			"Are you sure you want to go back to Rules list? If you go back to Rules list your changes will not be automatically saved.",
		"seo_rule_language_unsaved_changes": "You haven't saved changes. Are you sure you want to change the language?",
		"seo_rule_block_limit_error":
			"Maximum number of blocks for current rule is reached, you can only replace existing ones.",
		"seo_rule_block_limit": "Maximum number of blocks for your website is 5.",
		"seo_rule_block_char_limit": "Maximum number of characters for your block is {name}",
		"seo_rule_date_format": "Date format",
		"Equals": "Equals",
		"DoesNotEquals": "Does not equal",
		"Contains": "Contains",
		"DoesNotContains": "Does not contain",
		"MatchesRegex": "Matches regex",
		"DoesNotMatchRegex": "Does not match regex",
		"StartsWith": "Starts with",
		"DoesNotStartWith": "Does not start with",
		"EndsWith": "Ends with",
		"DoesNotEndWith": "Does not end with",
		"url_path": "URL Path",

		// Configurations
		"api_settings": "API Settings",
		"api_settings_hint":
			"Each setting toggle activates the triggering of relevant events when the specific functionalities are enabled.",
		"api_activate_confirm_title": "Activate Event Based API",
		"api_deactivate_confirm_title": "Deactivate Event Based API",
		"api_confirm_activate_description": "Are you sure want to activate Event Based API",
		"api_confirm_deactivate_description": "Are you sure want to deactivate Event Based API",
		"api_settings_success_txt": "Data has been changed successfully.",
		"event_based_api": "Event Based API",
		// Request approval
		"enter_comment": "Enter your comment",
		"reject_modal_request": "Are you sure you want to reject this request?",
		"cancel_modal_request": "Are you sure you want to cancel this request?",
		"by": "by:",

		"imageset": "Image Set",
		"imageSearch": "Search Image",
		"manageSets": "Manage Sets",
		"addImage": "Add Image",
		"emptyImage": "You haven't added Images to the Image Set. Please add one",
		"emptyImageSearch": "We couldn’t find any Images matching your search.",
		"images_enabled_success": "Image has been successfully enabled",
		"images_disabled_success": "Image has been successfully disabled",
		"img_required_message": "Image is required",
		"name_required_message": "Name is required",
		"image_name_validation_message":
			'Name can contain 2-50 characters: letters, spaces numbers and special characters excluding " \\ []',

		// Templates Default Color Descriptons
		"brand-color-1": [
			"Unread messages count in header",
			"Copyright info in footer",
			"Selected and hovered odds in Sportsbook",
			"Buttons in Account popups and Sportsbook",
			"Illustrations (partially) in Account popups",
		],

		"brand-color-2": [
			"Primary, secondary and tertiary buttons",
			"Selected menu items and subitems in header",
			"Selected item in mobile navigation bar",
			"Selected menu item in Right menu on mobile",
			"Opened menu item in Left menu on mobile",
			"Cookies and Announcement icon",
			"Floating menu item",
			"Selected and hovered chips in Casino filter",
			"Selected tab and sidebar item in Sportsbook",
			"Selected menu items in Rules",
		],

		"brand-color-text": [
			"Primary buttons text in Account popups",
			"Selected and hovered odds text in Sportsbook",
			"Selected tab text in Sportsbook",
		],

		"background-color-1": [
			"Header background",
			"Mobile navigation bar items background",
			"Mobile left and right menu items background",
			"Sport Jackpot background",
			"Floating menu items background",
			"Top matches background",
			"Regulations menu and content background",
			"Sportsbook background",
			"Multi view sidebar background",
		],

		"background-color-2": [
			"Website inner pages background",
			"Left menu background on mobile",
			"Cookies background",
			"Announcement background",
			"Sidebar background on desktop",
			"Floating menu background",
			"Promotion popup background",
			"Default odds background in Sportsbook",
			"Event dropdown and header background in Sportsbook",
		],

		"background-color-3": [
			"Secondary menu subitems background",
			"Mobile apps, social media icons, language bar background in footer",
			"Mobile Right menu background",
			"Top winners widget background on mobile",
			"Event widget, Sidebar selected tab and items background in Sportsbook",
		],

		"background-color-4": ["Events background in Sportsbook"],

		"background-color-5": [
			"Secondary menu background",
			"Casino Categories section background",
			"Casino default state tab background on mobile",
			"Promotion inner page content background",
			"Regulations menu subitems background",
			"Game grid and single game action icons background in Multi view",
		],

		"background-color-6": ["Footer background"],

		"text-color-1": [
			"Phone number in customer service on footer",
			"App adviser background",
			"Top matches text in Sportsbook",
			"Promotion name, description, popup header and body",
			"Main text color in Sportsbook",
		],

		"text-color-2": [
			"Top matches line next to the label and match date",
			"Language bar text and icon",
			"Social media icons, Mobile apps icons and text in footer",
			"Odds and markets in Sportsbook",
		],

		"text-color-3": [
			"Secondary menu items in header",
			"Subitems in Right menu on mobile",
			"Text and close icon in Cookies",
			"Main menu subitems, secondary menu items and labels in Left menu on mobile",
			"Announcement text and arrows",
			"Regulations menu items, subitems and body text",
		],

		"text-color-4": [
			"Main menu items, subitems and secondary menu subitems",
			"Default state menu items in mobile navigation bar",
			"Sidebar menu items and subitems, tooltip texts",
			"Featured Products text",
			"Block name, about company text and menus in footer",
			"Top winners widget label, ID and date",
			"Default state categories in Casino and Promotions",
		],

		// Template 5 Color Descriptons
		"brand-color-1-temp5": [
			"Unread messages count in header",
			"Copyright info in footer",
			"Selected and hovered odds in Sportsbook",
			"Hovered Featured Products",
			"Secondary and tertiary in Account popups and all buttons in Sportsbook",
			"Illustrations (partially) in Account popups",
		],

		"brand-color-2-temp5": [
			"All buttons in pages and Primary buttons in Account popups",
			"Selected menu items and subitems in header",
			"Sidebar background",
			"Selected item in mobile navigation bar",
			"Selected menu item in Right and Left menus on mobile",
			"Floating menu item",
			"Popups header background",
			"Selected tab and sidebar item in Sportsbook",
		],

		"brand-color-text-temp5": [
			"Default tabs in Account popups on desktop",
			"Selected and hovered odds text in Sportsbook",
			"Selected tab text in Sportsbook",
		],

		"background-color-1-temp5": [
			"Header background",
			"Mobile navigation bar items background",
			"Main menu subitems background",
			"Left menu background on mobile",
			"Regulations menu and body background",
			"Sport Jackpot and Top winners background",
			"Top matches background",
			"Sportsbook background",
		],

		"background-color-2-temp5": [
			"Website inner pages background",
			"Right menu background on mobile",
			"Casino filter popup background on mobile",
			"Promotion popup background",
			"Default odds background in Sportsbook",
			"Event dropdown and header background in Sportsbook",
		],

		"background-color-3-temp5": [
			"Secondary menu subitems background",
			"Mobile Left menu subitems background",
			"Top winners widget background on mobile",
			"Event widget, Sidebar selected tab and items background in Sportsbook",
		],

		"background-color-4-temp5": ["Leagues background in Sportsbook"],

		"background-color-5-temp5": [
			"Secondary menu background",
			"Customer service and Mobile apps background",
			"Casino categories and Providers sidebar background",
			"Announcement background",
			"Promotion inner page body background",
		],

		"background-color-6-temp5": ["Footer background"],

		"text-color-1-temp5": [
			"App adviser background",
			"Cookies text color",
			"Promotion name and description",
			"Top matches text in Sportsbook",
			"Main text color in Sportsbook",
		],

		"text-color-2-temp5": [
			"Language bar and dropdown items",
			"Featured Product icon and text",
			"Announcement text, close and arrow icons",
			"Default menu items and body in Rules",
			"Odds and markets in Sportsbook",
		],

		"text-color-3-temp5": [
			"Footer texts and social media icons",
			"Announcement details popup text",
			"Timezone text",
			"Provider games count and checkbox in sidebar",
		],

		"text-color-4-temp5": [
			"Main and Secondary menu items and subitems",
			"Default state menu items in mobile navigation bar",
			"Top winners widget label, ID and date",
			"Default state categories in Casino and Promotions",
		],
	},
};

export default en;
